import type { AxiosInstance } from "axios";
import MockAdapter from "axios-mock-adapter";

export function createMockAdapter(axios: AxiosInstance) {
  const mock = new MockAdapter(axios, { onNoMatch: "throwException" });

  mock.onPost("/api/v1/auth/login/").reply(200, {
    "refresh":
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoicmVmcmVzaCIsImV4cCI6MTc3MzQ3MzM2MywiaWF0IjoxNzczMzg2OTYzLCJqdGkiOiI1NzZkZWI1MTYyMWU0N2EwYTU0YTE2MzA1NmIzZGI4OCIsInVzZXJfaWQiOiIxIn0.o5QQ4KSHMxCPJ_JV4-iVc5-uEetw5qRj8-riBdmewU0",
    "access":
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzczMzg4NzYzLCJpYXQiOjE3NzMzODY5NjMsImp0aSI6IjIyZDJlNzQyNjE3MjQ1ODU4NmYxZDU4M2I0OTU5ZDk0IiwidXNlcl9pZCI6IjEifQ.9cDye9OZ2DNRCclIb7pGHejb6sXDSUaOAyQnU4uJeck",
  });

  mock.onGet("/api/v1/me").reply(200, {
    "id": 1,
    "username": "GTS",
    "email": "",
    "is_staff": true,
  });

  mock.onGet("/api/v1/meta/priorities").reply(200, [
    {
      "value": "L",
      "label": "Low",
    },
    {
      "value": "M",
      "label": "Medium",
    },
    {
      "value": "H",
      "label": "High",
    },
  ]);

  mock
    .onGet("/api/v1/ticket/?sideload=assignee%2Ccreated_by%2Cturbine%2Cclient%2Clocation")
    .reply(200, {
      "pagination": {
        "total_items": 100,
        "total_pages": 10,
        "current_page": 1,
        "per_page": 10,
      },
      "results": {
        "tickets": [
          {
            "id": "40000000-0000-0000-0000-000000000100",
            "created_at": "2026-04-02T11:05:19.601349Z",
            "updated_at": "2026-04-02T11:05:19.601349Z",
            "description":
              "Surface crack identified during last inspection. Grind, fill and re-coat affected area. Verify bond strength.",
            "name": "Structural repair - stress fracture",
            "location": "50000000-0000-0000-0000-000000000003",
            "turbine": "20000000-0000-0000-0000-000000000060",
            "client": "10000000-0000-0000-0000-000000000010",
            "assignee": 3,
            "items": [],
            "status": "NEW",
            "service": "S3",
            "ticket_number": 100,
            "client_case_nr": "INC787926",
            "deadline": "2025-12-29",
            "priority": "M",
            "created_by": 1,
          },
          {
            "id": "40000000-0000-0000-0000-000000000099",
            "created_at": "2026-04-02T11:05:19.601349Z",
            "updated_at": "2026-04-02T11:05:19.601349Z",
            "description":
              "Annual third-party inspection. Coordinate access with site team. All findings to be logged in asset system.",
            "name": "Post-storm visual inspection",
            "location": "50000000-0000-0000-0000-000000000003",
            "turbine": "20000000-0000-0000-0000-000000000054",
            "client": "10000000-0000-0000-0000-000000000009",
            "assignee": 3,
            "items": [],
            "status": "IN_PROGRESS",
            "service": "S2",
            "ticket_number": 99,
            "client_case_nr": "INC174878",
            "deadline": "2025-02-10",
            "priority": "H",
            "created_by": 1,
          },
          {
            "id": "40000000-0000-0000-0000-000000000098",
            "created_at": "2026-04-02T11:05:19.601349Z",
            "updated_at": "2026-04-02T11:05:19.601349Z",
            "description":
              "Pre-inspection cleaning required before scheduled structural assessment. Document blade condition before and after.",
            "name": "Dirt and debris removal",
            "location": "50000000-0000-0000-0000-000000000002",
            "turbine": "20000000-0000-0000-0000-000000000048",
            "client": "10000000-0000-0000-0000-000000000008",
            "assignee": 3,
            "items": [],
            "status": "IN_PROGRESS",
            "service": "S2",
            "ticket_number": 98,
            "client_case_nr": "INC503457",
            "deadline": "2025-07-25",
            "priority": "H",
            "created_by": 1,
          },
          {
            "id": "40000000-0000-0000-0000-000000000097",
            "created_at": "2026-04-02T11:05:19.601349Z",
            "updated_at": "2026-04-02T11:05:19.601349Z",
            "description":
              "Lightning strike recorded. Assess full blade length. Replace tip receptor if damaged. Restore earthing continuity.",
            "name": "Blade tip repair",
            "location": "50000000-0000-0000-0000-000000000002",
            "turbine": "20000000-0000-0000-0000-000000000041",
            "client": "10000000-0000-0000-0000-000000000007",
            "assignee": 3,
            "items": [],
            "status": "NEW",
            "service": "S3",
            "ticket_number": 97,
            "client_case_nr": "INC636265",
            "deadline": "2025-03-11",
            "priority": "M",
            "created_by": 1,
          },
          {
            "id": "40000000-0000-0000-0000-000000000096",
            "created_at": "2026-04-02T11:05:19.601349Z",
            "updated_at": "2026-04-02T11:05:19.601349Z",
            "description":
              "Hydrophobic coating degraded. Clean surface, inspect for micro-cracks and re-apply coating.",
            "name": "Blade surface cleaning",
            "location": "50000000-0000-0000-0000-000000000002",
            "turbine": "20000000-0000-0000-0000-000000000035",
            "client": "10000000-0000-0000-0000-000000000006",
            "assignee": 3,
            "items": [],
            "status": "IN_PROGRESS",
            "service": "S1",
            "ticket_number": 96,
            "client_case_nr": "INC961322",
            "deadline": "2025-05-28",
            "priority": "M",
            "created_by": 1,
          },
          {
            "id": "40000000-0000-0000-0000-000000000095",
            "created_at": "2026-04-02T11:05:19.601349Z",
            "updated_at": "2026-04-02T11:05:19.601349Z",
            "description":
              "Erosion shield delaminating from leading edge. Remove old shield, prep surface and bond new section.",
            "name": "Trailing edge bond repair",
            "location": "50000000-0000-0000-0000-000000000002",
            "turbine": "20000000-0000-0000-0000-000000000027",
            "client": "10000000-0000-0000-0000-000000000005",
            "assignee": 3,
            "items": [],
            "status": "NEW",
            "service": "S2",
            "ticket_number": 95,
            "client_case_nr": "INC392477",
            "deadline": "2025-08-29",
            "priority": "H",
            "created_by": 1,
          },
          {
            "id": "40000000-0000-0000-0000-000000000094",
            "created_at": "2026-04-02T11:05:19.601349Z",
            "updated_at": "2026-04-02T11:05:19.601349Z",
            "description":
              "Heavy insect contamination on leading edge reducing AEP. Manual cleaning with approved solvent required.",
            "name": "Pre-inspection cleaning",
            "location": "50000000-0000-0000-0000-000000000001",
            "turbine": "20000000-0000-0000-0000-000000000021",
            "client": "10000000-0000-0000-0000-000000000004",
            "assignee": 3,
            "items": [],
            "status": "IN_PROGRESS",
            "service": "S1",
            "ticket_number": 94,
            "client_case_nr": "INC805477",
            "deadline": "2025-06-18",
            "priority": "L",
            "created_by": 1,
          },
          {
            "id": "40000000-0000-0000-0000-000000000093",
            "created_at": "2026-04-02T11:05:19.601349Z",
            "updated_at": "2026-04-02T11:05:19.601349Z",
            "description":
              "Post-weather event inspection required. Assess structural integrity and report findings.",
            "name": "Trailing edge integrity inspection",
            "location": "50000000-0000-0000-0000-000000000001",
            "turbine": "20000000-0000-0000-0000-000000000014",
            "client": "10000000-0000-0000-0000-000000000003",
            "assignee": 3,
            "items": [],
            "status": "NEW",
            "service": "S1",
            "ticket_number": 93,
            "client_case_nr": "INC172792",
            "deadline": "2025-06-02",
            "priority": "L",
            "created_by": 1,
          },
          {
            "id": "40000000-0000-0000-0000-000000000092",
            "created_at": "2026-04-02T11:05:19.601349Z",
            "updated_at": "2026-04-02T11:05:19.601349Z",
            "description":
              "Annual third-party inspection. Coordinate access with site team. All findings to be logged in asset system.",
            "name": "Routine structural inspection",
            "location": "50000000-0000-0000-0000-000000000001",
            "turbine": "20000000-0000-0000-0000-000000000007",
            "client": "10000000-0000-0000-0000-000000000002",
            "assignee": 3,
            "items": [],
            "status": "NEW",
            "service": "S2",
            "ticket_number": 92,
            "client_case_nr": "INC755900",
            "deadline": "2025-04-29",
            "priority": "L",
            "created_by": 1,
          },
          {
            "id": "40000000-0000-0000-0000-000000000091",
            "created_at": "2026-04-02T11:05:19.601349Z",
            "updated_at": "2026-04-02T11:05:19.601349Z",
            "description":
              "Scheduled inspection per maintenance plan. Check leading and trailing edges for wear indicators.",
            "name": "Leading edge inspection",
            "location": "50000000-0000-0000-0000-000000000001",
            "turbine": "20000000-0000-0000-0000-000000000001",
            "client": "10000000-0000-0000-0000-000000000001",
            "assignee": 3,
            "items": [],
            "status": "NEW",
            "service": "S1",
            "ticket_number": 91,
            "client_case_nr": "INC751517",
            "deadline": "2025-03-30",
            "priority": "H",
            "created_by": 1,
          },
        ],
        "turbine": [
          {
            "id": "20000000-0000-0000-0000-000000000060",
            "created_at": "2026-04-02T07:39:44.060840Z",
            "updated_at": "2026-04-02T07:39:44.060840Z",
            "serial_number": "10060",
            "latitude": "55.95210",
            "longitude": "3.12340",
            "location": "50000000-0000-0000-0000-000000000003",
            "client": "10000000-0000-0000-0000-000000000010",
          },
          {
            "id": "20000000-0000-0000-0000-000000000041",
            "created_at": "2026-04-02T07:39:44.060840Z",
            "updated_at": "2026-04-02T07:39:44.060840Z",
            "serial_number": "10041",
            "latitude": "52.28210",
            "longitude": "4.71340",
            "location": "50000000-0000-0000-0000-000000000002",
            "client": "10000000-0000-0000-0000-000000000007",
          },
          {
            "id": "20000000-0000-0000-0000-000000000001",
            "created_at": "2026-04-02T07:39:44.060840Z",
            "updated_at": "2026-04-02T07:39:44.060840Z",
            "serial_number": "10001",
            "latitude": "59.98210",
            "longitude": "10.75130",
            "location": "50000000-0000-0000-0000-000000000001",
            "client": "10000000-0000-0000-0000-000000000001",
          },
          {
            "id": "20000000-0000-0000-0000-000000000021",
            "created_at": "2026-04-02T07:39:44.060840Z",
            "updated_at": "2026-04-02T07:39:44.060840Z",
            "serial_number": "10021",
            "latitude": "48.78210",
            "longitude": "2.41340",
            "location": "50000000-0000-0000-0000-000000000001",
            "client": "10000000-0000-0000-0000-000000000004",
          },
          {
            "id": "20000000-0000-0000-0000-000000000027",
            "created_at": "2026-04-02T07:39:44.060840Z",
            "updated_at": "2026-04-02T07:39:44.060840Z",
            "serial_number": "10027",
            "latitude": "52.18210",
            "longitude": "20.91340",
            "location": "50000000-0000-0000-0000-000000000002",
            "client": "10000000-0000-0000-0000-000000000005",
          },
          {
            "id": "20000000-0000-0000-0000-000000000048",
            "created_at": "2026-04-02T07:39:44.060840Z",
            "updated_at": "2026-04-02T07:39:44.060840Z",
            "serial_number": "10048",
            "latitude": "60.28210",
            "longitude": "24.91340",
            "location": "50000000-0000-0000-0000-000000000002",
            "client": "10000000-0000-0000-0000-000000000008",
          },
          {
            "id": "20000000-0000-0000-0000-000000000007",
            "created_at": "2026-04-02T07:39:44.060840Z",
            "updated_at": "2026-04-02T07:39:44.060840Z",
            "serial_number": "10007",
            "latitude": "52.68210",
            "longitude": "13.21340",
            "location": "50000000-0000-0000-0000-000000000001",
            "client": "10000000-0000-0000-0000-000000000002",
          },
          {
            "id": "20000000-0000-0000-0000-000000000054",
            "created_at": "2026-04-02T07:39:44.060840Z",
            "updated_at": "2026-04-02T07:39:44.060840Z",
            "serial_number": "10054",
            "latitude": "50.08210",
            "longitude": "14.21340",
            "location": "50000000-0000-0000-0000-000000000003",
            "client": "10000000-0000-0000-0000-000000000009",
          },
          {
            "id": "20000000-0000-0000-0000-000000000014",
            "created_at": "2026-04-02T07:39:44.060840Z",
            "updated_at": "2026-04-02T07:39:44.060840Z",
            "serial_number": "10014",
            "latitude": "40.58210",
            "longitude": "3.61340",
            "location": "50000000-0000-0000-0000-000000000001",
            "client": "10000000-0000-0000-0000-000000000003",
          },
          {
            "id": "20000000-0000-0000-0000-000000000035",
            "created_at": "2026-04-02T07:39:44.060840Z",
            "updated_at": "2026-04-02T07:39:44.060840Z",
            "serial_number": "10035",
            "latitude": "45.58210",
            "longitude": "9.11340",
            "location": "50000000-0000-0000-0000-000000000002",
            "client": "10000000-0000-0000-0000-000000000006",
          },
        ],
        "client": [
          {
            "id": "10000000-0000-0000-0000-000000000001",
            "created_at": "2026-03-17T11:12:30.441000Z",
            "updated_at": "2026-03-17T11:12:30.441000Z",
            "legal_name": "Nordvik Solutions AS",
            "tax_id": "NVKS-001",
            "contact_name": "Erik Haugen",
            "contact_email": "e.haugen@nordvik-solutions.no",
            "contact_phone": "+47 22 41 03 85",
            "billing_address": "Kirkegata 14, 0153 Oslo, Norway",
          },
          {
            "id": "10000000-0000-0000-0000-000000000002",
            "created_at": "2026-03-17T11:12:30.441000Z",
            "updated_at": "2026-03-17T11:12:30.441000Z",
            "legal_name": "Brenner & Wolf GmbH",
            "tax_id": "BRWL-002",
            "contact_name": "Sabine Brenner",
            "contact_email": "s.brenner@brennerwolf.de",
            "contact_phone": "+49 30 8872 4410",
            "billing_address": "Rosenthaler Str. 40, 10178 Berlin, Germany",
          },
          {
            "id": "10000000-0000-0000-0000-000000000003",
            "created_at": "2026-03-17T11:12:30.441000Z",
            "updated_at": "2026-03-17T11:12:30.441000Z",
            "legal_name": "Atlántica Logística SL",
            "tax_id": "ATLL-003",
            "contact_name": "Carlos Vega Ruiz",
            "contact_email": "c.vega@atlantica-log.es",
            "contact_phone": "+34 91 577 22 18",
            "billing_address": "Calle de Serrano 41, 28001 Madrid, Spain",
          },
          {
            "id": "10000000-0000-0000-0000-000000000004",
            "created_at": "2026-03-17T11:12:30.441000Z",
            "updated_at": "2026-03-17T11:12:30.441000Z",
            "legal_name": "Maison Lefebvre & Fils",
            "tax_id": "MLFR-004",
            "contact_name": "Hélène Moreau",
            "contact_email": "h.moreau@maisonfils.fr",
            "contact_phone": "+33 1 43 07 55 90",
            "billing_address": "12 Rue du Faubourg Saint-Antoine, 75012 Paris, France",
          },
          {
            "id": "10000000-0000-0000-0000-000000000005",
            "created_at": "2026-03-17T11:12:30.441000Z",
            "updated_at": "2026-03-17T11:12:30.441000Z",
            "legal_name": "Vantage Tech Sp. z o.o.",
            "tax_id": "VTPL-005",
            "contact_name": "Piotr Zawadzki",
            "contact_email": "p.zawadzki@vantagetech.pl",
            "contact_phone": "+48 22 630 44 71",
            "billing_address": "ul. Marszałkowska 111, 00-102 Warsaw, Poland",
          },
          {
            "id": "10000000-0000-0000-0000-000000000006",
            "created_at": "2026-03-17T11:12:30.441000Z",
            "updated_at": "2026-03-17T11:12:30.441000Z",
            "legal_name": "Riva Consulting Srl",
            "tax_id": "RVCN-006",
            "contact_name": "Giulia Ferretti",
            "contact_email": "g.ferretti@rivaconsulting.it",
            "contact_phone": "+39 02 8905 3370",
            "billing_address": "Via della Moscova 3, 20121 Milan, Italy",
          },
          {
            "id": "10000000-0000-0000-0000-000000000007",
            "created_at": "2026-03-17T11:12:30.441000Z",
            "updated_at": "2026-03-17T11:12:30.441000Z",
            "legal_name": "Delta Vermogen BV",
            "tax_id": "DLVB-007",
            "contact_name": "Martijn de Vries",
            "contact_email": "m.devries@deltavermogen.nl",
            "contact_phone": "+31 20 624 91 03",
            "billing_address": "Herengracht 282, 1016 BX Amsterdam, Netherlands",
          },
          {
            "id": "10000000-0000-0000-0000-000000000008",
            "created_at": "2026-03-17T11:12:30.441000Z",
            "updated_at": "2026-03-17T11:12:30.441000Z",
            "legal_name": "Hämäläinen Group Oy",
            "tax_id": "HMGF-008",
            "contact_name": "Sanna Korhonen",
            "contact_email": "s.korhonen@hamgroup.fi",
            "contact_phone": "+358 9 4783 2210",
            "billing_address": "Aleksanterinkatu 17, 00100 Helsinki, Finland",
          },
          {
            "id": "10000000-0000-0000-0000-000000000009",
            "created_at": "2026-03-17T11:12:30.441000Z",
            "updated_at": "2026-03-17T11:12:30.441000Z",
            "legal_name": "Kovář Industrial s.r.o.",
            "tax_id": "KVCZ-009",
            "contact_name": "Tomáš Kovář",
            "contact_email": "t.kovar@kovarindustrial.cz",
            "contact_phone": "+420 2 2421 8830",
            "billing_address": "Václavské náměstí 45, 110 00 Prague, Czech Republic",
          },
          {
            "id": "10000000-0000-0000-0000-000000000010",
            "created_at": "2026-03-17T11:12:30.441000Z",
            "updated_at": "2026-03-17T11:12:30.441000Z",
            "legal_name": "Strathmore Partners Ltd",
            "tax_id": "STGB-010",
            "contact_name": "Fiona MacAllister",
            "contact_email": "f.macallister@strathmorepartners.co.uk",
            "contact_phone": "+44 131 220 5544",
            "billing_address": "14 Charlotte Square, Edinburgh EH2 4DR, UK",
          },
        ],
        "assignee": [
          {
            "id": 3,
            "username": "user2",
            "email": "user2@email.com",
          },
        ],
        "created_by": [
          {
            "id": 1,
            "username": "GTS",
            "email": "",
          },
        ],
        "location": [
          {
            "id": "50000000-0000-0000-0000-000000000001",
            "created_at": "2026-03-17T09:12:30.441569Z",
            "updated_at": "2026-03-17T09:12:30.441569Z",
            "name": "Oslofjord Wind Park",
            "description": "Oslofjord Wind Park",
            "country": "LT",
          },
          {
            "id": "50000000-0000-0000-0000-000000000002",
            "created_at": "2026-03-17T09:12:30.441569Z",
            "updated_at": "2026-03-17T09:12:30.441569Z",
            "name": "Nordmarka Ridge",
            "description": "Nordmarka Ridge",
            "country": "LT",
          },
          {
            "id": "50000000-0000-0000-0000-000000000003",
            "created_at": "2026-03-17T09:12:30.441569Z",
            "updated_at": "2026-03-17T09:12:30.441569Z",
            "name": "Romerike Heights",
            "description": "Romerike Heights",
            "country": "LV",
          },
        ],
      },
    });

  mock.onGet("/api/v1/users/?current_page=1&per_page=100000").reply(200, {
    "pagination": {
      "total_items": 3,
      "total_pages": 1,
      "current_page": 1,
      "per_page": 100000,
    },
    "results": [
      {
        "id": 1,
        "username": "GTS",
        "email": "",
      },
      {
        "id": 2,
        "username": "user1",
        "email": "user@email.com",
      },
      {
        "id": 3,
        "username": "user2",
        "email": "user2@email.com",
      },
    ],
  });

  mock.onGet("/api/v1/meta/services").reply(200, [
    {
      "value": "S1",
      "label": "Service 1",
    },
    {
      "value": "S2",
      "label": "Service 2",
    },
    {
      "value": "S3",
      "label": "Service 3",
    },
  ]);

  mock.onGet("/api/v1/meta/ticket-statuses").reply(200, [
    {
      "value": "NEW",
      "label": "NEW",
    },
    {
      "value": "IN_PROGRESS",
      "label": "IN_PROGRESS",
    },
    {
      "value": "DONE",
      "label": "DONE",
    },
  ]);

  mock.onGet("/api/v1/work-orders/meta/").reply(200, {
    "locations": [
      {
        "id": "50000000-0000-0000-0000-000000000001",
        "created_at": "2026-03-17T09:12:30.441569Z",
        "updated_at": "2026-03-17T09:12:30.441569Z",
        "name": "Oslofjord Wind Park",
        "description": "Oslofjord Wind Park",
        "country": "LT",
      },
      {
        "id": "50000000-0000-0000-0000-000000000002",
        "created_at": "2026-03-17T09:12:30.441569Z",
        "updated_at": "2026-03-17T09:12:30.441569Z",
        "name": "Nordmarka Ridge",
        "description": "Nordmarka Ridge",
        "country": "LT",
      },
      {
        "id": "50000000-0000-0000-0000-000000000003",
        "created_at": "2026-03-17T09:12:30.441569Z",
        "updated_at": "2026-03-17T09:12:30.441569Z",
        "name": "Romerike Heights",
        "description": "Romerike Heights",
        "country": "LV",
      },
      {
        "id": "50000000-0000-0000-0000-000000000004",
        "created_at": "2026-03-17T09:12:30.441569Z",
        "updated_at": "2026-03-17T09:12:30.441569Z",
        "name": "Havelland West",
        "description": "Havelland West",
        "country": "EE",
      },
    ],
    "clients": [
      {
        "id": "10000000-0000-0000-0000-000000000001",
        "created_at": "2026-03-17T11:12:30.441000Z",
        "updated_at": "2026-03-17T11:12:30.441000Z",
        "legal_name": "Nordvik Solutions AS",
        "tax_id": "NVKS-001",
        "contact_name": "Erik Haugen",
        "contact_email": "e.haugen@nordvik-solutions.no",
        "contact_phone": "+47 22 41 03 85",
        "billing_address": "Kirkegata 14, 0153 Oslo, Norway",
      },
      {
        "id": "10000000-0000-0000-0000-000000000002",
        "created_at": "2026-03-17T11:12:30.441000Z",
        "updated_at": "2026-03-17T11:12:30.441000Z",
        "legal_name": "Brenner & Wolf GmbH",
        "tax_id": "BRWL-002",
        "contact_name": "Sabine Brenner",
        "contact_email": "s.brenner@brennerwolf.de",
        "contact_phone": "+49 30 8872 4410",
        "billing_address": "Rosenthaler Str. 40, 10178 Berlin, Germany",
      },
      {
        "id": "10000000-0000-0000-0000-000000000003",
        "created_at": "2026-03-17T11:12:30.441000Z",
        "updated_at": "2026-03-17T11:12:30.441000Z",
        "legal_name": "Atlántica Logística SL",
        "tax_id": "ATLL-003",
        "contact_name": "Carlos Vega Ruiz",
        "contact_email": "c.vega@atlantica-log.es",
        "contact_phone": "+34 91 577 22 18",
        "billing_address": "Calle de Serrano 41, 28001 Madrid, Spain",
      },
      {
        "id": "10000000-0000-0000-0000-000000000004",
        "created_at": "2026-03-17T11:12:30.441000Z",
        "updated_at": "2026-03-17T11:12:30.441000Z",
        "legal_name": "Maison Lefebvre & Fils",
        "tax_id": "MLFR-004",
        "contact_name": "Hélène Moreau",
        "contact_email": "h.moreau@maisonfils.fr",
        "contact_phone": "+33 1 43 07 55 90",
        "billing_address": "12 Rue du Faubourg Saint-Antoine, 75012 Paris, France",
      },
      {
        "id": "10000000-0000-0000-0000-000000000005",
        "created_at": "2026-03-17T11:12:30.441000Z",
        "updated_at": "2026-03-17T11:12:30.441000Z",
        "legal_name": "Vantage Tech Sp. z o.o.",
        "tax_id": "VTPL-005",
        "contact_name": "Piotr Zawadzki",
        "contact_email": "p.zawadzki@vantagetech.pl",
        "contact_phone": "+48 22 630 44 71",
        "billing_address": "ul. Marszałkowska 111, 00-102 Warsaw, Poland",
      },
      {
        "id": "10000000-0000-0000-0000-000000000006",
        "created_at": "2026-03-17T11:12:30.441000Z",
        "updated_at": "2026-03-17T11:12:30.441000Z",
        "legal_name": "Riva Consulting Srl",
        "tax_id": "RVCN-006",
        "contact_name": "Giulia Ferretti",
        "contact_email": "g.ferretti@rivaconsulting.it",
        "contact_phone": "+39 02 8905 3370",
        "billing_address": "Via della Moscova 3, 20121 Milan, Italy",
      },
      {
        "id": "10000000-0000-0000-0000-000000000007",
        "created_at": "2026-03-17T11:12:30.441000Z",
        "updated_at": "2026-03-17T11:12:30.441000Z",
        "legal_name": "Delta Vermogen BV",
        "tax_id": "DLVB-007",
        "contact_name": "Martijn de Vries",
        "contact_email": "m.devries@deltavermogen.nl",
        "contact_phone": "+31 20 624 91 03",
        "billing_address": "Herengracht 282, 1016 BX Amsterdam, Netherlands",
      },
      {
        "id": "10000000-0000-0000-0000-000000000008",
        "created_at": "2026-03-17T11:12:30.441000Z",
        "updated_at": "2026-03-17T11:12:30.441000Z",
        "legal_name": "Hämäläinen Group Oy",
        "tax_id": "HMGF-008",
        "contact_name": "Sanna Korhonen",
        "contact_email": "s.korhonen@hamgroup.fi",
        "contact_phone": "+358 9 4783 2210",
        "billing_address": "Aleksanterinkatu 17, 00100 Helsinki, Finland",
      },
      {
        "id": "10000000-0000-0000-0000-000000000009",
        "created_at": "2026-03-17T11:12:30.441000Z",
        "updated_at": "2026-03-17T11:12:30.441000Z",
        "legal_name": "Kovář Industrial s.r.o.",
        "tax_id": "KVCZ-009",
        "contact_name": "Tomáš Kovář",
        "contact_email": "t.kovar@kovarindustrial.cz",
        "contact_phone": "+420 2 2421 8830",
        "billing_address": "Václavské náměstí 45, 110 00 Prague, Czech Republic",
      },
      {
        "id": "10000000-0000-0000-0000-000000000010",
        "created_at": "2026-03-17T11:12:30.441000Z",
        "updated_at": "2026-03-17T11:12:30.441000Z",
        "legal_name": "Strathmore Partners Ltd",
        "tax_id": "STGB-010",
        "contact_name": "Fiona MacAllister",
        "contact_email": "f.macallister@strathmorepartners.co.uk",
        "contact_phone": "+44 131 220 5544",
        "billing_address": "14 Charlotte Square, Edinburgh EH2 4DR, UK",
      },
      {
        "id": "10000000-0000-0000-0000-000000000011",
        "created_at": "2026-03-17T11:12:30.441000Z",
        "updated_at": "2026-03-17T11:12:30.441000Z",
        "legal_name": "Balkan Trade EOOD",
        "tax_id": "BTBG-011",
        "contact_name": "Georgi Dimitrov",
        "contact_email": "g.dimitrov@balkantrade.bg",
        "contact_phone": "+359 2 981 67 43",
        "billing_address": "bul. Vitosha 89, 1000 Sofia, Bulgaria",
      },
      {
        "id": "10000000-0000-0000-0000-000000000012",
        "created_at": "2026-03-17T11:12:30.441000Z",
        "updated_at": "2026-03-17T11:12:30.441000Z",
        "legal_name": "Egersund Havbruk AS",
        "tax_id": "EHNO-012",
        "contact_name": "Ingrid Thorsen",
        "contact_email": "i.thorsen@egersundhav.no",
        "contact_phone": "+47 51 49 02 77",
        "billing_address": "Strandgaten 7, 4370 Egersund, Norway",
      },
      {
        "id": "10000000-0000-0000-0000-000000000013",
        "created_at": "2026-03-17T11:12:30.441000Z",
        "updated_at": "2026-03-17T11:12:30.441000Z",
        "legal_name": "Alföld Kereskedelmi Kft.",
        "tax_id": "AKHU-013",
        "contact_name": "Ágnes Fekete",
        "contact_email": "a.fekete@alfoldker.hu",
        "contact_phone": "+36 1 329 8840",
        "billing_address": "Váci út 33, 1134 Budapest, Hungary",
      },
      {
        "id": "10000000-0000-0000-0000-000000000014",
        "created_at": "2026-03-17T11:12:30.441000Z",
        "updated_at": "2026-03-17T11:12:30.441000Z",
        "legal_name": "Crux Digital Lda",
        "tax_id": "CXPT-014",
        "contact_name": "Miguel Carvalho",
        "contact_email": "m.carvalho@cruxdigital.pt",
        "contact_phone": "+351 21 342 88 60",
        "billing_address": "Rua do Ouro 132, 1100-061 Lisbon, Portugal",
      },
      {
        "id": "10000000-0000-0000-0000-000000000015",
        "created_at": "2026-03-17T11:12:30.441000Z",
        "updated_at": "2026-03-17T11:12:30.441000Z",
        "legal_name": "Kronos Yazılım A.Ş.",
        "tax_id": "KRTR-015",
        "contact_name": "Ayşe Yıldız",
        "contact_email": "a.yildiz@kronosyazilim.com.tr",
        "contact_phone": "+90 212 347 66 90",
        "billing_address": "Büyükdere Cad. 185, 34394 Istanbul, Turkey",
      },
    ],
    "turbines": [
      {
        "id": "20000000-0000-0000-0000-000000000001",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10001",
        "latitude": "59.98210",
        "longitude": "10.75130",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000001",
      },
      {
        "id": "20000000-0000-0000-0000-000000000002",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10002",
        "latitude": "60.11340",
        "longitude": "10.88210",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000001",
      },
      {
        "id": "20000000-0000-0000-0000-000000000003",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10003",
        "latitude": "60.23410",
        "longitude": "10.91020",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000001",
      },
      {
        "id": "20000000-0000-0000-0000-000000000004",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10004",
        "latitude": "60.38120",
        "longitude": "11.03340",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000001",
      },
      {
        "id": "20000000-0000-0000-0000-000000000005",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10005",
        "latitude": "60.45210",
        "longitude": "11.12450",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000001",
      },
      {
        "id": "20000000-0000-0000-0000-000000000006",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10006",
        "latitude": "60.51030",
        "longitude": "11.20170",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000001",
      },
      {
        "id": "20000000-0000-0000-0000-000000000007",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10007",
        "latitude": "52.68210",
        "longitude": "13.21340",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000002",
      },
      {
        "id": "20000000-0000-0000-0000-000000000008",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10008",
        "latitude": "52.73410",
        "longitude": "13.30120",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000002",
      },
      {
        "id": "20000000-0000-0000-0000-000000000009",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10009",
        "latitude": "52.80120",
        "longitude": "13.45210",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000002",
      },
      {
        "id": "20000000-0000-0000-0000-000000000010",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10010",
        "latitude": "52.87340",
        "longitude": "13.52030",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000002",
      },
      {
        "id": "20000000-0000-0000-0000-000000000011",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10011",
        "latitude": "52.94120",
        "longitude": "13.61180",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000002",
      },
      {
        "id": "20000000-0000-0000-0000-000000000012",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10012",
        "latitude": "53.01230",
        "longitude": "13.70340",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000002",
      },
      {
        "id": "20000000-0000-0000-0000-000000000013",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10013",
        "latitude": "53.08410",
        "longitude": "13.79120",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000002",
      },
      {
        "id": "20000000-0000-0000-0000-000000000014",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10014",
        "latitude": "40.58210",
        "longitude": "3.61340",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000003",
      },
      {
        "id": "20000000-0000-0000-0000-000000000015",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10015",
        "latitude": "40.65120",
        "longitude": "3.70210",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000003",
      },
      {
        "id": "20000000-0000-0000-0000-000000000016",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10016",
        "latitude": "40.72340",
        "longitude": "3.82030",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000003",
      },
      {
        "id": "20000000-0000-0000-0000-000000000017",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10017",
        "latitude": "40.80130",
        "longitude": "3.93410",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000003",
      },
      {
        "id": "20000000-0000-0000-0000-000000000018",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10018",
        "latitude": "40.88210",
        "longitude": "4.05120",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000003",
      },
      {
        "id": "20000000-0000-0000-0000-000000000019",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10019",
        "latitude": "40.95120",
        "longitude": "4.12340",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000003",
      },
      {
        "id": "20000000-0000-0000-0000-000000000020",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10020",
        "latitude": "41.02340",
        "longitude": "4.20180",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000003",
      },
      {
        "id": "20000000-0000-0000-0000-000000000021",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10021",
        "latitude": "48.78210",
        "longitude": "2.41340",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000004",
      },
      {
        "id": "20000000-0000-0000-0000-000000000022",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10022",
        "latitude": "48.85120",
        "longitude": "2.50210",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000004",
      },
      {
        "id": "20000000-0000-0000-0000-000000000023",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10023",
        "latitude": "48.92340",
        "longitude": "2.62030",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000004",
      },
      {
        "id": "20000000-0000-0000-0000-000000000024",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10024",
        "latitude": "49.00130",
        "longitude": "2.73410",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000004",
      },
      {
        "id": "20000000-0000-0000-0000-000000000025",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10025",
        "latitude": "49.08210",
        "longitude": "2.85120",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000004",
      },
      {
        "id": "20000000-0000-0000-0000-000000000026",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10026",
        "latitude": "49.15120",
        "longitude": "2.92340",
        "location": "50000000-0000-0000-0000-000000000001",
        "client": "10000000-0000-0000-0000-000000000004",
      },
      {
        "id": "20000000-0000-0000-0000-000000000027",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10027",
        "latitude": "52.18210",
        "longitude": "20.91340",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000005",
      },
      {
        "id": "20000000-0000-0000-0000-000000000028",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10028",
        "latitude": "52.25120",
        "longitude": "21.00210",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000005",
      },
      {
        "id": "20000000-0000-0000-0000-000000000029",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10029",
        "latitude": "52.32340",
        "longitude": "21.12030",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000005",
      },
      {
        "id": "20000000-0000-0000-0000-000000000030",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10030",
        "latitude": "52.40130",
        "longitude": "21.23410",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000005",
      },
      {
        "id": "20000000-0000-0000-0000-000000000031",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10031",
        "latitude": "52.48210",
        "longitude": "21.35120",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000005",
      },
      {
        "id": "20000000-0000-0000-0000-000000000032",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10032",
        "latitude": "52.55120",
        "longitude": "21.42340",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000005",
      },
      {
        "id": "20000000-0000-0000-0000-000000000033",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10033",
        "latitude": "52.62340",
        "longitude": "21.50180",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000005",
      },
      {
        "id": "20000000-0000-0000-0000-000000000034",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10034",
        "latitude": "52.70130",
        "longitude": "21.59120",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000005",
      },
      {
        "id": "20000000-0000-0000-0000-000000000035",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10035",
        "latitude": "45.58210",
        "longitude": "9.11340",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000006",
      },
      {
        "id": "20000000-0000-0000-0000-000000000036",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10036",
        "latitude": "45.65120",
        "longitude": "9.20210",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000006",
      },
      {
        "id": "20000000-0000-0000-0000-000000000037",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10037",
        "latitude": "45.72340",
        "longitude": "9.32030",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000006",
      },
      {
        "id": "20000000-0000-0000-0000-000000000038",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10038",
        "latitude": "45.80130",
        "longitude": "9.43410",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000006",
      },
      {
        "id": "20000000-0000-0000-0000-000000000039",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10039",
        "latitude": "45.88210",
        "longitude": "9.55120",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000006",
      },
      {
        "id": "20000000-0000-0000-0000-000000000040",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10040",
        "latitude": "45.95120",
        "longitude": "9.62340",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000006",
      },
      {
        "id": "20000000-0000-0000-0000-000000000041",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10041",
        "latitude": "52.28210",
        "longitude": "4.71340",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000007",
      },
      {
        "id": "20000000-0000-0000-0000-000000000042",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10042",
        "latitude": "52.35120",
        "longitude": "4.80210",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000007",
      },
      {
        "id": "20000000-0000-0000-0000-000000000043",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10043",
        "latitude": "52.42340",
        "longitude": "4.92030",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000007",
      },
      {
        "id": "20000000-0000-0000-0000-000000000044",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10044",
        "latitude": "52.50130",
        "longitude": "5.03410",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000007",
      },
      {
        "id": "20000000-0000-0000-0000-000000000045",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10045",
        "latitude": "52.58210",
        "longitude": "5.15120",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000007",
      },
      {
        "id": "20000000-0000-0000-0000-000000000046",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10046",
        "latitude": "52.65120",
        "longitude": "5.22340",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000007",
      },
      {
        "id": "20000000-0000-0000-0000-000000000047",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10047",
        "latitude": "52.72340",
        "longitude": "5.30180",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000007",
      },
      {
        "id": "20000000-0000-0000-0000-000000000048",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10048",
        "latitude": "60.28210",
        "longitude": "24.91340",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000008",
      },
      {
        "id": "20000000-0000-0000-0000-000000000049",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10049",
        "latitude": "60.35120",
        "longitude": "25.00210",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000008",
      },
      {
        "id": "20000000-0000-0000-0000-000000000050",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10050",
        "latitude": "60.42340",
        "longitude": "25.12030",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000008",
      },
      {
        "id": "20000000-0000-0000-0000-000000000051",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10051",
        "latitude": "60.50130",
        "longitude": "25.23410",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000008",
      },
      {
        "id": "20000000-0000-0000-0000-000000000052",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10052",
        "latitude": "60.58210",
        "longitude": "25.35120",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000008",
      },
      {
        "id": "20000000-0000-0000-0000-000000000053",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10053",
        "latitude": "60.65120",
        "longitude": "25.42340",
        "location": "50000000-0000-0000-0000-000000000002",
        "client": "10000000-0000-0000-0000-000000000008",
      },
      {
        "id": "20000000-0000-0000-0000-000000000054",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10054",
        "latitude": "50.08210",
        "longitude": "14.21340",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000009",
      },
      {
        "id": "20000000-0000-0000-0000-000000000055",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10055",
        "latitude": "50.15120",
        "longitude": "14.30210",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000009",
      },
      {
        "id": "20000000-0000-0000-0000-000000000056",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10056",
        "latitude": "50.22340",
        "longitude": "14.42030",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000009",
      },
      {
        "id": "20000000-0000-0000-0000-000000000057",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10057",
        "latitude": "50.30130",
        "longitude": "14.53410",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000009",
      },
      {
        "id": "20000000-0000-0000-0000-000000000058",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10058",
        "latitude": "50.38210",
        "longitude": "14.65120",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000009",
      },
      {
        "id": "20000000-0000-0000-0000-000000000059",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10059",
        "latitude": "50.45120",
        "longitude": "14.72340",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000009",
      },
      {
        "id": "20000000-0000-0000-0000-000000000060",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10060",
        "latitude": "55.95210",
        "longitude": "3.12340",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000010",
      },
      {
        "id": "20000000-0000-0000-0000-000000000061",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10061",
        "latitude": "56.02340",
        "longitude": "3.20180",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000010",
      },
      {
        "id": "20000000-0000-0000-0000-000000000062",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10062",
        "latitude": "56.10130",
        "longitude": "3.29120",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000010",
      },
      {
        "id": "20000000-0000-0000-0000-000000000063",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10063",
        "latitude": "56.18210",
        "longitude": "3.38340",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000010",
      },
      {
        "id": "20000000-0000-0000-0000-000000000064",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10064",
        "latitude": "56.25120",
        "longitude": "3.47210",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000010",
      },
      {
        "id": "20000000-0000-0000-0000-000000000065",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10065",
        "latitude": "56.32340",
        "longitude": "3.56030",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000010",
      },
      {
        "id": "20000000-0000-0000-0000-000000000066",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10066",
        "latitude": "56.40130",
        "longitude": "3.65120",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000010",
      },
      {
        "id": "20000000-0000-0000-0000-000000000067",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10067",
        "latitude": "42.65210",
        "longitude": "23.21340",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000011",
      },
      {
        "id": "20000000-0000-0000-0000-000000000068",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10068",
        "latitude": "42.72340",
        "longitude": "23.30210",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000011",
      },
      {
        "id": "20000000-0000-0000-0000-000000000069",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10069",
        "latitude": "42.80130",
        "longitude": "23.42030",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000011",
      },
      {
        "id": "20000000-0000-0000-0000-000000000070",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10070",
        "latitude": "42.88210",
        "longitude": "23.53410",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000011",
      },
      {
        "id": "20000000-0000-0000-0000-000000000071",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10071",
        "latitude": "42.95120",
        "longitude": "23.65120",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000011",
      },
      {
        "id": "20000000-0000-0000-0000-000000000072",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10072",
        "latitude": "43.02340",
        "longitude": "23.72340",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000011",
      },
      {
        "id": "20000000-0000-0000-0000-000000000073",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10073",
        "latitude": "58.45210",
        "longitude": "5.91340",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000012",
      },
      {
        "id": "20000000-0000-0000-0000-000000000074",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10074",
        "latitude": "58.52340",
        "longitude": "6.20210",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000012",
      },
      {
        "id": "20000000-0000-0000-0000-000000000075",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10075",
        "latitude": "58.60130",
        "longitude": "6.09120",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000012",
      },
      {
        "id": "20000000-0000-0000-0000-000000000076",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10076",
        "latitude": "58.68210",
        "longitude": "6.18340",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000012",
      },
      {
        "id": "20000000-0000-0000-0000-000000000077",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10077",
        "latitude": "58.75120",
        "longitude": "6.27210",
        "location": "50000000-0000-0000-0000-000000000003",
        "client": "10000000-0000-0000-0000-000000000012",
      },
      {
        "id": "20000000-0000-0000-0000-000000000078",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10078",
        "latitude": "47.45210",
        "longitude": "19.01340",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000013",
      },
      {
        "id": "20000000-0000-0000-0000-000000000079",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10079",
        "latitude": "47.52340",
        "longitude": "19.10210",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000013",
      },
      {
        "id": "20000000-0000-0000-0000-000000000080",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10080",
        "latitude": "47.60130",
        "longitude": "19.19120",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000013",
      },
      {
        "id": "20000000-0000-0000-0000-000000000081",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10081",
        "latitude": "47.68210",
        "longitude": "19.28340",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000013",
      },
      {
        "id": "20000000-0000-0000-0000-000000000082",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10082",
        "latitude": "47.75120",
        "longitude": "19.37210",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000013",
      },
      {
        "id": "20000000-0000-0000-0000-000000000083",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10083",
        "latitude": "47.82340",
        "longitude": "19.46030",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000013",
      },
      {
        "id": "20000000-0000-0000-0000-000000000084",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10084",
        "latitude": "38.75210",
        "longitude": "-9.11340",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000014",
      },
      {
        "id": "20000000-0000-0000-0000-000000000085",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10085",
        "latitude": "38.82340",
        "longitude": "-9.00210",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000014",
      },
      {
        "id": "20000000-0000-0000-0000-000000000086",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10086",
        "latitude": "38.90130",
        "longitude": "-8.89120",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000014",
      },
      {
        "id": "20000000-0000-0000-0000-000000000087",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10087",
        "latitude": "38.98210",
        "longitude": "-8.78340",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000014",
      },
      {
        "id": "20000000-0000-0000-0000-000000000088",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10088",
        "latitude": "39.05120",
        "longitude": "-8.67210",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000014",
      },
      {
        "id": "20000000-0000-0000-0000-000000000089",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10089",
        "latitude": "39.12340",
        "longitude": "-8.56030",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000014",
      },
      {
        "id": "20000000-0000-0000-0000-000000000090",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10090",
        "latitude": "39.20130",
        "longitude": "-8.45120",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000014",
      },
      {
        "id": "20000000-0000-0000-0000-000000000091",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10091",
        "latitude": "41.08210",
        "longitude": "28.81340",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000015",
      },
      {
        "id": "20000000-0000-0000-0000-000000000092",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10092",
        "latitude": "41.15120",
        "longitude": "28.90210",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000015",
      },
      {
        "id": "20000000-0000-0000-0000-000000000093",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10093",
        "latitude": "41.22340",
        "longitude": "28.99120",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000015",
      },
      {
        "id": "20000000-0000-0000-0000-000000000094",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10094",
        "latitude": "41.30130",
        "longitude": "29.08340",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000015",
      },
      {
        "id": "20000000-0000-0000-0000-000000000095",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10095",
        "latitude": "41.38210",
        "longitude": "29.17210",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000015",
      },
      {
        "id": "20000000-0000-0000-0000-000000000096",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10096",
        "latitude": "41.45120",
        "longitude": "29.26030",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000015",
      },
      {
        "id": "20000000-0000-0000-0000-000000000097",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10097",
        "latitude": "41.52340",
        "longitude": "29.35120",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000015",
      },
      {
        "id": "20000000-0000-0000-0000-000000000098",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10098",
        "latitude": "41.60130",
        "longitude": "29.44340",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000015",
      },
      {
        "id": "20000000-0000-0000-0000-000000000099",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10099",
        "latitude": "41.68210",
        "longitude": "29.53210",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000015",
      },
      {
        "id": "20000000-0000-0000-0000-000000000100",
        "created_at": "2026-04-02T07:39:44.060840Z",
        "updated_at": "2026-04-02T07:39:44.060840Z",
        "serial_number": "10100",
        "latitude": "41.75120",
        "longitude": "29.62030",
        "location": "50000000-0000-0000-0000-000000000004",
        "client": "10000000-0000-0000-0000-000000000015",
      },
    ],
    "blades": [
      {
        "id": "30000000-0000-0000-0000-000000000001",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-001",
        "model": "m-001",
        "serial_number": "30001",
        "turbine": "20000000-0000-0000-0000-000000000001",
      },
      {
        "id": "30000000-0000-0000-0000-000000000002",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-002",
        "model": "m-002",
        "serial_number": "30002",
        "turbine": "20000000-0000-0000-0000-000000000001",
      },
      {
        "id": "30000000-0000-0000-0000-000000000003",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-003",
        "model": "m-003",
        "serial_number": "30003",
        "turbine": "20000000-0000-0000-0000-000000000001",
      },
      {
        "id": "30000000-0000-0000-0000-000000000004",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-004",
        "model": "m-004",
        "serial_number": "30004",
        "turbine": "20000000-0000-0000-0000-000000000002",
      },
      {
        "id": "30000000-0000-0000-0000-000000000005",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-005",
        "model": "m-005",
        "serial_number": "30005",
        "turbine": "20000000-0000-0000-0000-000000000002",
      },
      {
        "id": "30000000-0000-0000-0000-000000000006",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-006",
        "model": "m-006",
        "serial_number": "30006",
        "turbine": "20000000-0000-0000-0000-000000000002",
      },
      {
        "id": "30000000-0000-0000-0000-000000000007",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-007",
        "model": "m-007",
        "serial_number": "30007",
        "turbine": "20000000-0000-0000-0000-000000000003",
      },
      {
        "id": "30000000-0000-0000-0000-000000000008",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-008",
        "model": "m-008",
        "serial_number": "30008",
        "turbine": "20000000-0000-0000-0000-000000000003",
      },
      {
        "id": "30000000-0000-0000-0000-000000000009",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-009",
        "model": "m-009",
        "serial_number": "30009",
        "turbine": "20000000-0000-0000-0000-000000000003",
      },
      {
        "id": "30000000-0000-0000-0000-000000000010",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-010",
        "model": "m-010",
        "serial_number": "30010",
        "turbine": "20000000-0000-0000-0000-000000000004",
      },
      {
        "id": "30000000-0000-0000-0000-000000000011",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-011",
        "model": "m-011",
        "serial_number": "30011",
        "turbine": "20000000-0000-0000-0000-000000000004",
      },
      {
        "id": "30000000-0000-0000-0000-000000000012",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-012",
        "model": "m-012",
        "serial_number": "30012",
        "turbine": "20000000-0000-0000-0000-000000000004",
      },
      {
        "id": "30000000-0000-0000-0000-000000000013",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-013",
        "model": "m-013",
        "serial_number": "30013",
        "turbine": "20000000-0000-0000-0000-000000000005",
      },
      {
        "id": "30000000-0000-0000-0000-000000000014",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-014",
        "model": "m-014",
        "serial_number": "30014",
        "turbine": "20000000-0000-0000-0000-000000000005",
      },
      {
        "id": "30000000-0000-0000-0000-000000000015",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-015",
        "model": "m-015",
        "serial_number": "30015",
        "turbine": "20000000-0000-0000-0000-000000000005",
      },
      {
        "id": "30000000-0000-0000-0000-000000000016",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-016",
        "model": "m-016",
        "serial_number": "30016",
        "turbine": "20000000-0000-0000-0000-000000000006",
      },
      {
        "id": "30000000-0000-0000-0000-000000000017",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-017",
        "model": "m-017",
        "serial_number": "30017",
        "turbine": "20000000-0000-0000-0000-000000000006",
      },
      {
        "id": "30000000-0000-0000-0000-000000000018",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-018",
        "model": "m-018",
        "serial_number": "30018",
        "turbine": "20000000-0000-0000-0000-000000000006",
      },
      {
        "id": "30000000-0000-0000-0000-000000000019",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-019",
        "model": "m-019",
        "serial_number": "30019",
        "turbine": "20000000-0000-0000-0000-000000000007",
      },
      {
        "id": "30000000-0000-0000-0000-000000000020",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-020",
        "model": "m-020",
        "serial_number": "30020",
        "turbine": "20000000-0000-0000-0000-000000000007",
      },
      {
        "id": "30000000-0000-0000-0000-000000000021",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-021",
        "model": "m-021",
        "serial_number": "30021",
        "turbine": "20000000-0000-0000-0000-000000000007",
      },
      {
        "id": "30000000-0000-0000-0000-000000000022",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-022",
        "model": "m-022",
        "serial_number": "30022",
        "turbine": "20000000-0000-0000-0000-000000000008",
      },
      {
        "id": "30000000-0000-0000-0000-000000000023",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-023",
        "model": "m-023",
        "serial_number": "30023",
        "turbine": "20000000-0000-0000-0000-000000000008",
      },
      {
        "id": "30000000-0000-0000-0000-000000000024",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-024",
        "model": "m-024",
        "serial_number": "30024",
        "turbine": "20000000-0000-0000-0000-000000000008",
      },
      {
        "id": "30000000-0000-0000-0000-000000000025",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-025",
        "model": "m-025",
        "serial_number": "30025",
        "turbine": "20000000-0000-0000-0000-000000000009",
      },
      {
        "id": "30000000-0000-0000-0000-000000000026",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-026",
        "model": "m-026",
        "serial_number": "30026",
        "turbine": "20000000-0000-0000-0000-000000000009",
      },
      {
        "id": "30000000-0000-0000-0000-000000000027",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-027",
        "model": "m-027",
        "serial_number": "30027",
        "turbine": "20000000-0000-0000-0000-000000000009",
      },
      {
        "id": "30000000-0000-0000-0000-000000000028",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-028",
        "model": "m-028",
        "serial_number": "30028",
        "turbine": "20000000-0000-0000-0000-000000000010",
      },
      {
        "id": "30000000-0000-0000-0000-000000000029",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-029",
        "model": "m-029",
        "serial_number": "30029",
        "turbine": "20000000-0000-0000-0000-000000000010",
      },
      {
        "id": "30000000-0000-0000-0000-000000000030",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-030",
        "model": "m-030",
        "serial_number": "30030",
        "turbine": "20000000-0000-0000-0000-000000000010",
      },
      {
        "id": "30000000-0000-0000-0000-000000000031",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-031",
        "model": "m-031",
        "serial_number": "30031",
        "turbine": "20000000-0000-0000-0000-000000000011",
      },
      {
        "id": "30000000-0000-0000-0000-000000000032",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-032",
        "model": "m-032",
        "serial_number": "30032",
        "turbine": "20000000-0000-0000-0000-000000000011",
      },
      {
        "id": "30000000-0000-0000-0000-000000000033",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-033",
        "model": "m-033",
        "serial_number": "30033",
        "turbine": "20000000-0000-0000-0000-000000000011",
      },
      {
        "id": "30000000-0000-0000-0000-000000000034",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-034",
        "model": "m-034",
        "serial_number": "30034",
        "turbine": "20000000-0000-0000-0000-000000000012",
      },
      {
        "id": "30000000-0000-0000-0000-000000000035",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-035",
        "model": "m-035",
        "serial_number": "30035",
        "turbine": "20000000-0000-0000-0000-000000000012",
      },
      {
        "id": "30000000-0000-0000-0000-000000000036",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-036",
        "model": "m-036",
        "serial_number": "30036",
        "turbine": "20000000-0000-0000-0000-000000000012",
      },
      {
        "id": "30000000-0000-0000-0000-000000000037",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-037",
        "model": "m-037",
        "serial_number": "30037",
        "turbine": "20000000-0000-0000-0000-000000000013",
      },
      {
        "id": "30000000-0000-0000-0000-000000000038",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-038",
        "model": "m-038",
        "serial_number": "30038",
        "turbine": "20000000-0000-0000-0000-000000000013",
      },
      {
        "id": "30000000-0000-0000-0000-000000000039",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-039",
        "model": "m-039",
        "serial_number": "30039",
        "turbine": "20000000-0000-0000-0000-000000000013",
      },
      {
        "id": "30000000-0000-0000-0000-000000000040",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-040",
        "model": "m-040",
        "serial_number": "30040",
        "turbine": "20000000-0000-0000-0000-000000000014",
      },
      {
        "id": "30000000-0000-0000-0000-000000000041",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-041",
        "model": "m-041",
        "serial_number": "30041",
        "turbine": "20000000-0000-0000-0000-000000000014",
      },
      {
        "id": "30000000-0000-0000-0000-000000000042",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-042",
        "model": "m-042",
        "serial_number": "30042",
        "turbine": "20000000-0000-0000-0000-000000000014",
      },
      {
        "id": "30000000-0000-0000-0000-000000000043",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-043",
        "model": "m-043",
        "serial_number": "30043",
        "turbine": "20000000-0000-0000-0000-000000000015",
      },
      {
        "id": "30000000-0000-0000-0000-000000000044",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-044",
        "model": "m-044",
        "serial_number": "30044",
        "turbine": "20000000-0000-0000-0000-000000000015",
      },
      {
        "id": "30000000-0000-0000-0000-000000000045",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-045",
        "model": "m-045",
        "serial_number": "30045",
        "turbine": "20000000-0000-0000-0000-000000000015",
      },
      {
        "id": "30000000-0000-0000-0000-000000000046",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-046",
        "model": "m-046",
        "serial_number": "30046",
        "turbine": "20000000-0000-0000-0000-000000000016",
      },
      {
        "id": "30000000-0000-0000-0000-000000000047",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-047",
        "model": "m-047",
        "serial_number": "30047",
        "turbine": "20000000-0000-0000-0000-000000000016",
      },
      {
        "id": "30000000-0000-0000-0000-000000000048",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-048",
        "model": "m-048",
        "serial_number": "30048",
        "turbine": "20000000-0000-0000-0000-000000000016",
      },
      {
        "id": "30000000-0000-0000-0000-000000000049",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-049",
        "model": "m-049",
        "serial_number": "30049",
        "turbine": "20000000-0000-0000-0000-000000000017",
      },
      {
        "id": "30000000-0000-0000-0000-000000000050",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-050",
        "model": "m-050",
        "serial_number": "30050",
        "turbine": "20000000-0000-0000-0000-000000000017",
      },
      {
        "id": "30000000-0000-0000-0000-000000000051",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-051",
        "model": "m-051",
        "serial_number": "30051",
        "turbine": "20000000-0000-0000-0000-000000000017",
      },
      {
        "id": "30000000-0000-0000-0000-000000000052",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-052",
        "model": "m-052",
        "serial_number": "30052",
        "turbine": "20000000-0000-0000-0000-000000000018",
      },
      {
        "id": "30000000-0000-0000-0000-000000000053",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-053",
        "model": "m-053",
        "serial_number": "30053",
        "turbine": "20000000-0000-0000-0000-000000000018",
      },
      {
        "id": "30000000-0000-0000-0000-000000000054",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-054",
        "model": "m-054",
        "serial_number": "30054",
        "turbine": "20000000-0000-0000-0000-000000000018",
      },
      {
        "id": "30000000-0000-0000-0000-000000000055",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-055",
        "model": "m-055",
        "serial_number": "30055",
        "turbine": "20000000-0000-0000-0000-000000000019",
      },
      {
        "id": "30000000-0000-0000-0000-000000000056",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-056",
        "model": "m-056",
        "serial_number": "30056",
        "turbine": "20000000-0000-0000-0000-000000000019",
      },
      {
        "id": "30000000-0000-0000-0000-000000000057",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-057",
        "model": "m-057",
        "serial_number": "30057",
        "turbine": "20000000-0000-0000-0000-000000000019",
      },
      {
        "id": "30000000-0000-0000-0000-000000000058",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-058",
        "model": "m-058",
        "serial_number": "30058",
        "turbine": "20000000-0000-0000-0000-000000000020",
      },
      {
        "id": "30000000-0000-0000-0000-000000000059",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-059",
        "model": "m-059",
        "serial_number": "30059",
        "turbine": "20000000-0000-0000-0000-000000000020",
      },
      {
        "id": "30000000-0000-0000-0000-000000000060",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-060",
        "model": "m-060",
        "serial_number": "30060",
        "turbine": "20000000-0000-0000-0000-000000000020",
      },
      {
        "id": "30000000-0000-0000-0000-000000000061",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-061",
        "model": "m-061",
        "serial_number": "30061",
        "turbine": "20000000-0000-0000-0000-000000000021",
      },
      {
        "id": "30000000-0000-0000-0000-000000000062",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-062",
        "model": "m-062",
        "serial_number": "30062",
        "turbine": "20000000-0000-0000-0000-000000000021",
      },
      {
        "id": "30000000-0000-0000-0000-000000000063",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-063",
        "model": "m-063",
        "serial_number": "30063",
        "turbine": "20000000-0000-0000-0000-000000000021",
      },
      {
        "id": "30000000-0000-0000-0000-000000000064",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-064",
        "model": "m-064",
        "serial_number": "30064",
        "turbine": "20000000-0000-0000-0000-000000000022",
      },
      {
        "id": "30000000-0000-0000-0000-000000000065",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-065",
        "model": "m-065",
        "serial_number": "30065",
        "turbine": "20000000-0000-0000-0000-000000000022",
      },
      {
        "id": "30000000-0000-0000-0000-000000000066",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-066",
        "model": "m-066",
        "serial_number": "30066",
        "turbine": "20000000-0000-0000-0000-000000000022",
      },
      {
        "id": "30000000-0000-0000-0000-000000000067",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-067",
        "model": "m-067",
        "serial_number": "30067",
        "turbine": "20000000-0000-0000-0000-000000000023",
      },
      {
        "id": "30000000-0000-0000-0000-000000000068",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-068",
        "model": "m-068",
        "serial_number": "30068",
        "turbine": "20000000-0000-0000-0000-000000000023",
      },
      {
        "id": "30000000-0000-0000-0000-000000000069",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-069",
        "model": "m-069",
        "serial_number": "30069",
        "turbine": "20000000-0000-0000-0000-000000000023",
      },
      {
        "id": "30000000-0000-0000-0000-000000000070",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-070",
        "model": "m-070",
        "serial_number": "30070",
        "turbine": "20000000-0000-0000-0000-000000000024",
      },
      {
        "id": "30000000-0000-0000-0000-000000000071",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-071",
        "model": "m-071",
        "serial_number": "30071",
        "turbine": "20000000-0000-0000-0000-000000000024",
      },
      {
        "id": "30000000-0000-0000-0000-000000000072",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-072",
        "model": "m-072",
        "serial_number": "30072",
        "turbine": "20000000-0000-0000-0000-000000000024",
      },
      {
        "id": "30000000-0000-0000-0000-000000000073",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-073",
        "model": "m-073",
        "serial_number": "30073",
        "turbine": "20000000-0000-0000-0000-000000000025",
      },
      {
        "id": "30000000-0000-0000-0000-000000000074",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-074",
        "model": "m-074",
        "serial_number": "30074",
        "turbine": "20000000-0000-0000-0000-000000000025",
      },
      {
        "id": "30000000-0000-0000-0000-000000000075",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-075",
        "model": "m-075",
        "serial_number": "30075",
        "turbine": "20000000-0000-0000-0000-000000000025",
      },
      {
        "id": "30000000-0000-0000-0000-000000000076",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-076",
        "model": "m-076",
        "serial_number": "30076",
        "turbine": "20000000-0000-0000-0000-000000000026",
      },
      {
        "id": "30000000-0000-0000-0000-000000000077",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-077",
        "model": "m-077",
        "serial_number": "30077",
        "turbine": "20000000-0000-0000-0000-000000000026",
      },
      {
        "id": "30000000-0000-0000-0000-000000000078",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-078",
        "model": "m-078",
        "serial_number": "30078",
        "turbine": "20000000-0000-0000-0000-000000000026",
      },
      {
        "id": "30000000-0000-0000-0000-000000000079",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-079",
        "model": "m-079",
        "serial_number": "30079",
        "turbine": "20000000-0000-0000-0000-000000000027",
      },
      {
        "id": "30000000-0000-0000-0000-000000000080",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-080",
        "model": "m-080",
        "serial_number": "30080",
        "turbine": "20000000-0000-0000-0000-000000000027",
      },
      {
        "id": "30000000-0000-0000-0000-000000000081",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-081",
        "model": "m-081",
        "serial_number": "30081",
        "turbine": "20000000-0000-0000-0000-000000000027",
      },
      {
        "id": "30000000-0000-0000-0000-000000000082",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-082",
        "model": "m-082",
        "serial_number": "30082",
        "turbine": "20000000-0000-0000-0000-000000000028",
      },
      {
        "id": "30000000-0000-0000-0000-000000000083",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-083",
        "model": "m-083",
        "serial_number": "30083",
        "turbine": "20000000-0000-0000-0000-000000000028",
      },
      {
        "id": "30000000-0000-0000-0000-000000000084",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-084",
        "model": "m-084",
        "serial_number": "30084",
        "turbine": "20000000-0000-0000-0000-000000000028",
      },
      {
        "id": "30000000-0000-0000-0000-000000000085",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-085",
        "model": "m-085",
        "serial_number": "30085",
        "turbine": "20000000-0000-0000-0000-000000000029",
      },
      {
        "id": "30000000-0000-0000-0000-000000000086",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-086",
        "model": "m-086",
        "serial_number": "30086",
        "turbine": "20000000-0000-0000-0000-000000000029",
      },
      {
        "id": "30000000-0000-0000-0000-000000000087",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-087",
        "model": "m-087",
        "serial_number": "30087",
        "turbine": "20000000-0000-0000-0000-000000000029",
      },
      {
        "id": "30000000-0000-0000-0000-000000000088",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-088",
        "model": "m-088",
        "serial_number": "30088",
        "turbine": "20000000-0000-0000-0000-000000000030",
      },
      {
        "id": "30000000-0000-0000-0000-000000000089",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-089",
        "model": "m-089",
        "serial_number": "30089",
        "turbine": "20000000-0000-0000-0000-000000000030",
      },
      {
        "id": "30000000-0000-0000-0000-000000000090",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-090",
        "model": "m-090",
        "serial_number": "30090",
        "turbine": "20000000-0000-0000-0000-000000000030",
      },
      {
        "id": "30000000-0000-0000-0000-000000000091",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-091",
        "model": "m-091",
        "serial_number": "30091",
        "turbine": "20000000-0000-0000-0000-000000000031",
      },
      {
        "id": "30000000-0000-0000-0000-000000000092",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-092",
        "model": "m-092",
        "serial_number": "30092",
        "turbine": "20000000-0000-0000-0000-000000000031",
      },
      {
        "id": "30000000-0000-0000-0000-000000000093",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-093",
        "model": "m-093",
        "serial_number": "30093",
        "turbine": "20000000-0000-0000-0000-000000000031",
      },
      {
        "id": "30000000-0000-0000-0000-000000000094",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-094",
        "model": "m-094",
        "serial_number": "30094",
        "turbine": "20000000-0000-0000-0000-000000000032",
      },
      {
        "id": "30000000-0000-0000-0000-000000000095",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-095",
        "model": "m-095",
        "serial_number": "30095",
        "turbine": "20000000-0000-0000-0000-000000000032",
      },
      {
        "id": "30000000-0000-0000-0000-000000000096",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-096",
        "model": "m-096",
        "serial_number": "30096",
        "turbine": "20000000-0000-0000-0000-000000000032",
      },
      {
        "id": "30000000-0000-0000-0000-000000000097",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-097",
        "model": "m-097",
        "serial_number": "30097",
        "turbine": "20000000-0000-0000-0000-000000000033",
      },
      {
        "id": "30000000-0000-0000-0000-000000000098",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-098",
        "model": "m-098",
        "serial_number": "30098",
        "turbine": "20000000-0000-0000-0000-000000000033",
      },
      {
        "id": "30000000-0000-0000-0000-000000000099",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-099",
        "model": "m-099",
        "serial_number": "30099",
        "turbine": "20000000-0000-0000-0000-000000000033",
      },
      {
        "id": "30000000-0000-0000-0000-000000000100",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-100",
        "model": "m-100",
        "serial_number": "30100",
        "turbine": "20000000-0000-0000-0000-000000000034",
      },
      {
        "id": "30000000-0000-0000-0000-000000000101",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-101",
        "model": "m-101",
        "serial_number": "30101",
        "turbine": "20000000-0000-0000-0000-000000000034",
      },
      {
        "id": "30000000-0000-0000-0000-000000000102",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-102",
        "model": "m-102",
        "serial_number": "30102",
        "turbine": "20000000-0000-0000-0000-000000000034",
      },
      {
        "id": "30000000-0000-0000-0000-000000000103",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-103",
        "model": "m-103",
        "serial_number": "30103",
        "turbine": "20000000-0000-0000-0000-000000000035",
      },
      {
        "id": "30000000-0000-0000-0000-000000000104",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-104",
        "model": "m-104",
        "serial_number": "30104",
        "turbine": "20000000-0000-0000-0000-000000000035",
      },
      {
        "id": "30000000-0000-0000-0000-000000000105",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-105",
        "model": "m-105",
        "serial_number": "30105",
        "turbine": "20000000-0000-0000-0000-000000000035",
      },
      {
        "id": "30000000-0000-0000-0000-000000000106",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-106",
        "model": "m-106",
        "serial_number": "30106",
        "turbine": "20000000-0000-0000-0000-000000000036",
      },
      {
        "id": "30000000-0000-0000-0000-000000000107",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-107",
        "model": "m-107",
        "serial_number": "30107",
        "turbine": "20000000-0000-0000-0000-000000000036",
      },
      {
        "id": "30000000-0000-0000-0000-000000000108",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-108",
        "model": "m-108",
        "serial_number": "30108",
        "turbine": "20000000-0000-0000-0000-000000000036",
      },
      {
        "id": "30000000-0000-0000-0000-000000000109",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-109",
        "model": "m-109",
        "serial_number": "30109",
        "turbine": "20000000-0000-0000-0000-000000000037",
      },
      {
        "id": "30000000-0000-0000-0000-000000000110",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-110",
        "model": "m-110",
        "serial_number": "30110",
        "turbine": "20000000-0000-0000-0000-000000000037",
      },
      {
        "id": "30000000-0000-0000-0000-000000000111",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-111",
        "model": "m-111",
        "serial_number": "30111",
        "turbine": "20000000-0000-0000-0000-000000000037",
      },
      {
        "id": "30000000-0000-0000-0000-000000000112",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-112",
        "model": "m-112",
        "serial_number": "30112",
        "turbine": "20000000-0000-0000-0000-000000000038",
      },
      {
        "id": "30000000-0000-0000-0000-000000000113",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-113",
        "model": "m-113",
        "serial_number": "30113",
        "turbine": "20000000-0000-0000-0000-000000000038",
      },
      {
        "id": "30000000-0000-0000-0000-000000000114",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-114",
        "model": "m-114",
        "serial_number": "30114",
        "turbine": "20000000-0000-0000-0000-000000000038",
      },
      {
        "id": "30000000-0000-0000-0000-000000000115",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-115",
        "model": "m-115",
        "serial_number": "30115",
        "turbine": "20000000-0000-0000-0000-000000000039",
      },
      {
        "id": "30000000-0000-0000-0000-000000000116",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-116",
        "model": "m-116",
        "serial_number": "30116",
        "turbine": "20000000-0000-0000-0000-000000000039",
      },
      {
        "id": "30000000-0000-0000-0000-000000000117",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-117",
        "model": "m-117",
        "serial_number": "30117",
        "turbine": "20000000-0000-0000-0000-000000000039",
      },
      {
        "id": "30000000-0000-0000-0000-000000000118",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-118",
        "model": "m-118",
        "serial_number": "30118",
        "turbine": "20000000-0000-0000-0000-000000000040",
      },
      {
        "id": "30000000-0000-0000-0000-000000000119",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-119",
        "model": "m-119",
        "serial_number": "30119",
        "turbine": "20000000-0000-0000-0000-000000000040",
      },
      {
        "id": "30000000-0000-0000-0000-000000000120",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-120",
        "model": "m-120",
        "serial_number": "30120",
        "turbine": "20000000-0000-0000-0000-000000000040",
      },
      {
        "id": "30000000-0000-0000-0000-000000000121",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-121",
        "model": "m-121",
        "serial_number": "30121",
        "turbine": "20000000-0000-0000-0000-000000000041",
      },
      {
        "id": "30000000-0000-0000-0000-000000000122",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-122",
        "model": "m-122",
        "serial_number": "30122",
        "turbine": "20000000-0000-0000-0000-000000000041",
      },
      {
        "id": "30000000-0000-0000-0000-000000000123",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-123",
        "model": "m-123",
        "serial_number": "30123",
        "turbine": "20000000-0000-0000-0000-000000000041",
      },
      {
        "id": "30000000-0000-0000-0000-000000000124",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-124",
        "model": "m-124",
        "serial_number": "30124",
        "turbine": "20000000-0000-0000-0000-000000000042",
      },
      {
        "id": "30000000-0000-0000-0000-000000000125",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-125",
        "model": "m-125",
        "serial_number": "30125",
        "turbine": "20000000-0000-0000-0000-000000000042",
      },
      {
        "id": "30000000-0000-0000-0000-000000000126",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-126",
        "model": "m-126",
        "serial_number": "30126",
        "turbine": "20000000-0000-0000-0000-000000000042",
      },
      {
        "id": "30000000-0000-0000-0000-000000000127",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-127",
        "model": "m-127",
        "serial_number": "30127",
        "turbine": "20000000-0000-0000-0000-000000000043",
      },
      {
        "id": "30000000-0000-0000-0000-000000000128",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-128",
        "model": "m-128",
        "serial_number": "30128",
        "turbine": "20000000-0000-0000-0000-000000000043",
      },
      {
        "id": "30000000-0000-0000-0000-000000000129",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-129",
        "model": "m-129",
        "serial_number": "30129",
        "turbine": "20000000-0000-0000-0000-000000000043",
      },
      {
        "id": "30000000-0000-0000-0000-000000000130",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-130",
        "model": "m-130",
        "serial_number": "30130",
        "turbine": "20000000-0000-0000-0000-000000000044",
      },
      {
        "id": "30000000-0000-0000-0000-000000000131",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-131",
        "model": "m-131",
        "serial_number": "30131",
        "turbine": "20000000-0000-0000-0000-000000000044",
      },
      {
        "id": "30000000-0000-0000-0000-000000000132",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-132",
        "model": "m-132",
        "serial_number": "30132",
        "turbine": "20000000-0000-0000-0000-000000000044",
      },
      {
        "id": "30000000-0000-0000-0000-000000000133",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-133",
        "model": "m-133",
        "serial_number": "30133",
        "turbine": "20000000-0000-0000-0000-000000000045",
      },
      {
        "id": "30000000-0000-0000-0000-000000000134",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-134",
        "model": "m-134",
        "serial_number": "30134",
        "turbine": "20000000-0000-0000-0000-000000000045",
      },
      {
        "id": "30000000-0000-0000-0000-000000000135",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-135",
        "model": "m-135",
        "serial_number": "30135",
        "turbine": "20000000-0000-0000-0000-000000000045",
      },
      {
        "id": "30000000-0000-0000-0000-000000000136",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-136",
        "model": "m-136",
        "serial_number": "30136",
        "turbine": "20000000-0000-0000-0000-000000000046",
      },
      {
        "id": "30000000-0000-0000-0000-000000000137",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-137",
        "model": "m-137",
        "serial_number": "30137",
        "turbine": "20000000-0000-0000-0000-000000000046",
      },
      {
        "id": "30000000-0000-0000-0000-000000000138",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-138",
        "model": "m-138",
        "serial_number": "30138",
        "turbine": "20000000-0000-0000-0000-000000000046",
      },
      {
        "id": "30000000-0000-0000-0000-000000000139",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-139",
        "model": "m-139",
        "serial_number": "30139",
        "turbine": "20000000-0000-0000-0000-000000000047",
      },
      {
        "id": "30000000-0000-0000-0000-000000000140",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-140",
        "model": "m-140",
        "serial_number": "30140",
        "turbine": "20000000-0000-0000-0000-000000000047",
      },
      {
        "id": "30000000-0000-0000-0000-000000000141",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-141",
        "model": "m-141",
        "serial_number": "30141",
        "turbine": "20000000-0000-0000-0000-000000000047",
      },
      {
        "id": "30000000-0000-0000-0000-000000000142",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-142",
        "model": "m-142",
        "serial_number": "30142",
        "turbine": "20000000-0000-0000-0000-000000000048",
      },
      {
        "id": "30000000-0000-0000-0000-000000000143",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-143",
        "model": "m-143",
        "serial_number": "30143",
        "turbine": "20000000-0000-0000-0000-000000000048",
      },
      {
        "id": "30000000-0000-0000-0000-000000000144",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-144",
        "model": "m-144",
        "serial_number": "30144",
        "turbine": "20000000-0000-0000-0000-000000000048",
      },
      {
        "id": "30000000-0000-0000-0000-000000000145",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-145",
        "model": "m-145",
        "serial_number": "30145",
        "turbine": "20000000-0000-0000-0000-000000000049",
      },
      {
        "id": "30000000-0000-0000-0000-000000000146",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-146",
        "model": "m-146",
        "serial_number": "30146",
        "turbine": "20000000-0000-0000-0000-000000000049",
      },
      {
        "id": "30000000-0000-0000-0000-000000000147",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-147",
        "model": "m-147",
        "serial_number": "30147",
        "turbine": "20000000-0000-0000-0000-000000000049",
      },
      {
        "id": "30000000-0000-0000-0000-000000000148",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-148",
        "model": "m-148",
        "serial_number": "30148",
        "turbine": "20000000-0000-0000-0000-000000000050",
      },
      {
        "id": "30000000-0000-0000-0000-000000000149",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-149",
        "model": "m-149",
        "serial_number": "30149",
        "turbine": "20000000-0000-0000-0000-000000000050",
      },
      {
        "id": "30000000-0000-0000-0000-000000000150",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-150",
        "model": "m-150",
        "serial_number": "30150",
        "turbine": "20000000-0000-0000-0000-000000000050",
      },
      {
        "id": "30000000-0000-0000-0000-000000000151",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-151",
        "model": "m-151",
        "serial_number": "30151",
        "turbine": "20000000-0000-0000-0000-000000000051",
      },
      {
        "id": "30000000-0000-0000-0000-000000000152",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-152",
        "model": "m-152",
        "serial_number": "30152",
        "turbine": "20000000-0000-0000-0000-000000000051",
      },
      {
        "id": "30000000-0000-0000-0000-000000000153",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-153",
        "model": "m-153",
        "serial_number": "30153",
        "turbine": "20000000-0000-0000-0000-000000000051",
      },
      {
        "id": "30000000-0000-0000-0000-000000000154",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-154",
        "model": "m-154",
        "serial_number": "30154",
        "turbine": "20000000-0000-0000-0000-000000000052",
      },
      {
        "id": "30000000-0000-0000-0000-000000000155",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-155",
        "model": "m-155",
        "serial_number": "30155",
        "turbine": "20000000-0000-0000-0000-000000000052",
      },
      {
        "id": "30000000-0000-0000-0000-000000000156",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-156",
        "model": "m-156",
        "serial_number": "30156",
        "turbine": "20000000-0000-0000-0000-000000000052",
      },
      {
        "id": "30000000-0000-0000-0000-000000000157",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-157",
        "model": "m-157",
        "serial_number": "30157",
        "turbine": "20000000-0000-0000-0000-000000000053",
      },
      {
        "id": "30000000-0000-0000-0000-000000000158",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-158",
        "model": "m-158",
        "serial_number": "30158",
        "turbine": "20000000-0000-0000-0000-000000000053",
      },
      {
        "id": "30000000-0000-0000-0000-000000000159",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-159",
        "model": "m-159",
        "serial_number": "30159",
        "turbine": "20000000-0000-0000-0000-000000000053",
      },
      {
        "id": "30000000-0000-0000-0000-000000000160",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-160",
        "model": "m-160",
        "serial_number": "30160",
        "turbine": "20000000-0000-0000-0000-000000000054",
      },
      {
        "id": "30000000-0000-0000-0000-000000000161",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-161",
        "model": "m-161",
        "serial_number": "30161",
        "turbine": "20000000-0000-0000-0000-000000000054",
      },
      {
        "id": "30000000-0000-0000-0000-000000000162",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-162",
        "model": "m-162",
        "serial_number": "30162",
        "turbine": "20000000-0000-0000-0000-000000000054",
      },
      {
        "id": "30000000-0000-0000-0000-000000000163",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-163",
        "model": "m-163",
        "serial_number": "30163",
        "turbine": "20000000-0000-0000-0000-000000000055",
      },
      {
        "id": "30000000-0000-0000-0000-000000000164",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-164",
        "model": "m-164",
        "serial_number": "30164",
        "turbine": "20000000-0000-0000-0000-000000000055",
      },
      {
        "id": "30000000-0000-0000-0000-000000000165",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-165",
        "model": "m-165",
        "serial_number": "30165",
        "turbine": "20000000-0000-0000-0000-000000000055",
      },
      {
        "id": "30000000-0000-0000-0000-000000000166",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-166",
        "model": "m-166",
        "serial_number": "30166",
        "turbine": "20000000-0000-0000-0000-000000000056",
      },
      {
        "id": "30000000-0000-0000-0000-000000000167",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-167",
        "model": "m-167",
        "serial_number": "30167",
        "turbine": "20000000-0000-0000-0000-000000000056",
      },
      {
        "id": "30000000-0000-0000-0000-000000000168",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-168",
        "model": "m-168",
        "serial_number": "30168",
        "turbine": "20000000-0000-0000-0000-000000000056",
      },
      {
        "id": "30000000-0000-0000-0000-000000000169",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-169",
        "model": "m-169",
        "serial_number": "30169",
        "turbine": "20000000-0000-0000-0000-000000000057",
      },
      {
        "id": "30000000-0000-0000-0000-000000000170",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-170",
        "model": "m-170",
        "serial_number": "30170",
        "turbine": "20000000-0000-0000-0000-000000000057",
      },
      {
        "id": "30000000-0000-0000-0000-000000000171",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-171",
        "model": "m-171",
        "serial_number": "30171",
        "turbine": "20000000-0000-0000-0000-000000000057",
      },
      {
        "id": "30000000-0000-0000-0000-000000000172",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-172",
        "model": "m-172",
        "serial_number": "30172",
        "turbine": "20000000-0000-0000-0000-000000000058",
      },
      {
        "id": "30000000-0000-0000-0000-000000000173",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-173",
        "model": "m-173",
        "serial_number": "30173",
        "turbine": "20000000-0000-0000-0000-000000000058",
      },
      {
        "id": "30000000-0000-0000-0000-000000000174",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-174",
        "model": "m-174",
        "serial_number": "30174",
        "turbine": "20000000-0000-0000-0000-000000000058",
      },
      {
        "id": "30000000-0000-0000-0000-000000000175",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-175",
        "model": "m-175",
        "serial_number": "30175",
        "turbine": "20000000-0000-0000-0000-000000000059",
      },
      {
        "id": "30000000-0000-0000-0000-000000000176",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-176",
        "model": "m-176",
        "serial_number": "30176",
        "turbine": "20000000-0000-0000-0000-000000000059",
      },
      {
        "id": "30000000-0000-0000-0000-000000000177",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-177",
        "model": "m-177",
        "serial_number": "30177",
        "turbine": "20000000-0000-0000-0000-000000000059",
      },
      {
        "id": "30000000-0000-0000-0000-000000000178",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-178",
        "model": "m-178",
        "serial_number": "30178",
        "turbine": "20000000-0000-0000-0000-000000000060",
      },
      {
        "id": "30000000-0000-0000-0000-000000000179",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-179",
        "model": "m-179",
        "serial_number": "30179",
        "turbine": "20000000-0000-0000-0000-000000000060",
      },
      {
        "id": "30000000-0000-0000-0000-000000000180",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-180",
        "model": "m-180",
        "serial_number": "30180",
        "turbine": "20000000-0000-0000-0000-000000000060",
      },
      {
        "id": "30000000-0000-0000-0000-000000000181",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-181",
        "model": "m-181",
        "serial_number": "30181",
        "turbine": "20000000-0000-0000-0000-000000000061",
      },
      {
        "id": "30000000-0000-0000-0000-000000000182",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-182",
        "model": "m-182",
        "serial_number": "30182",
        "turbine": "20000000-0000-0000-0000-000000000061",
      },
      {
        "id": "30000000-0000-0000-0000-000000000183",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-183",
        "model": "m-183",
        "serial_number": "30183",
        "turbine": "20000000-0000-0000-0000-000000000061",
      },
      {
        "id": "30000000-0000-0000-0000-000000000184",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-184",
        "model": "m-184",
        "serial_number": "30184",
        "turbine": "20000000-0000-0000-0000-000000000062",
      },
      {
        "id": "30000000-0000-0000-0000-000000000185",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-185",
        "model": "m-185",
        "serial_number": "30185",
        "turbine": "20000000-0000-0000-0000-000000000062",
      },
      {
        "id": "30000000-0000-0000-0000-000000000186",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-186",
        "model": "m-186",
        "serial_number": "30186",
        "turbine": "20000000-0000-0000-0000-000000000062",
      },
      {
        "id": "30000000-0000-0000-0000-000000000187",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-187",
        "model": "m-187",
        "serial_number": "30187",
        "turbine": "20000000-0000-0000-0000-000000000063",
      },
      {
        "id": "30000000-0000-0000-0000-000000000188",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-188",
        "model": "m-188",
        "serial_number": "30188",
        "turbine": "20000000-0000-0000-0000-000000000063",
      },
      {
        "id": "30000000-0000-0000-0000-000000000189",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-189",
        "model": "m-189",
        "serial_number": "30189",
        "turbine": "20000000-0000-0000-0000-000000000063",
      },
      {
        "id": "30000000-0000-0000-0000-000000000190",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-190",
        "model": "m-190",
        "serial_number": "30190",
        "turbine": "20000000-0000-0000-0000-000000000064",
      },
      {
        "id": "30000000-0000-0000-0000-000000000191",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-191",
        "model": "m-191",
        "serial_number": "30191",
        "turbine": "20000000-0000-0000-0000-000000000064",
      },
      {
        "id": "30000000-0000-0000-0000-000000000192",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-192",
        "model": "m-192",
        "serial_number": "30192",
        "turbine": "20000000-0000-0000-0000-000000000064",
      },
      {
        "id": "30000000-0000-0000-0000-000000000193",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-193",
        "model": "m-193",
        "serial_number": "30193",
        "turbine": "20000000-0000-0000-0000-000000000065",
      },
      {
        "id": "30000000-0000-0000-0000-000000000194",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-194",
        "model": "m-194",
        "serial_number": "30194",
        "turbine": "20000000-0000-0000-0000-000000000065",
      },
      {
        "id": "30000000-0000-0000-0000-000000000195",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-195",
        "model": "m-195",
        "serial_number": "30195",
        "turbine": "20000000-0000-0000-0000-000000000065",
      },
      {
        "id": "30000000-0000-0000-0000-000000000196",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-196",
        "model": "m-196",
        "serial_number": "30196",
        "turbine": "20000000-0000-0000-0000-000000000066",
      },
      {
        "id": "30000000-0000-0000-0000-000000000197",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-197",
        "model": "m-197",
        "serial_number": "30197",
        "turbine": "20000000-0000-0000-0000-000000000066",
      },
      {
        "id": "30000000-0000-0000-0000-000000000198",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-198",
        "model": "m-198",
        "serial_number": "30198",
        "turbine": "20000000-0000-0000-0000-000000000066",
      },
      {
        "id": "30000000-0000-0000-0000-000000000199",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-199",
        "model": "m-199",
        "serial_number": "30199",
        "turbine": "20000000-0000-0000-0000-000000000067",
      },
      {
        "id": "30000000-0000-0000-0000-000000000200",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-200",
        "model": "m-200",
        "serial_number": "30200",
        "turbine": "20000000-0000-0000-0000-000000000067",
      },
      {
        "id": "30000000-0000-0000-0000-000000000201",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-201",
        "model": "m-201",
        "serial_number": "30201",
        "turbine": "20000000-0000-0000-0000-000000000067",
      },
      {
        "id": "30000000-0000-0000-0000-000000000202",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-202",
        "model": "m-202",
        "serial_number": "30202",
        "turbine": "20000000-0000-0000-0000-000000000068",
      },
      {
        "id": "30000000-0000-0000-0000-000000000203",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-203",
        "model": "m-203",
        "serial_number": "30203",
        "turbine": "20000000-0000-0000-0000-000000000068",
      },
      {
        "id": "30000000-0000-0000-0000-000000000204",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-204",
        "model": "m-204",
        "serial_number": "30204",
        "turbine": "20000000-0000-0000-0000-000000000068",
      },
      {
        "id": "30000000-0000-0000-0000-000000000205",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-205",
        "model": "m-205",
        "serial_number": "30205",
        "turbine": "20000000-0000-0000-0000-000000000069",
      },
      {
        "id": "30000000-0000-0000-0000-000000000206",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-206",
        "model": "m-206",
        "serial_number": "30206",
        "turbine": "20000000-0000-0000-0000-000000000069",
      },
      {
        "id": "30000000-0000-0000-0000-000000000207",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-207",
        "model": "m-207",
        "serial_number": "30207",
        "turbine": "20000000-0000-0000-0000-000000000069",
      },
      {
        "id": "30000000-0000-0000-0000-000000000208",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-208",
        "model": "m-208",
        "serial_number": "30208",
        "turbine": "20000000-0000-0000-0000-000000000070",
      },
      {
        "id": "30000000-0000-0000-0000-000000000209",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-209",
        "model": "m-209",
        "serial_number": "30209",
        "turbine": "20000000-0000-0000-0000-000000000070",
      },
      {
        "id": "30000000-0000-0000-0000-000000000210",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-210",
        "model": "m-210",
        "serial_number": "30210",
        "turbine": "20000000-0000-0000-0000-000000000070",
      },
      {
        "id": "30000000-0000-0000-0000-000000000211",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-211",
        "model": "m-211",
        "serial_number": "30211",
        "turbine": "20000000-0000-0000-0000-000000000071",
      },
      {
        "id": "30000000-0000-0000-0000-000000000212",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-212",
        "model": "m-212",
        "serial_number": "30212",
        "turbine": "20000000-0000-0000-0000-000000000071",
      },
      {
        "id": "30000000-0000-0000-0000-000000000213",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-213",
        "model": "m-213",
        "serial_number": "30213",
        "turbine": "20000000-0000-0000-0000-000000000071",
      },
      {
        "id": "30000000-0000-0000-0000-000000000214",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-214",
        "model": "m-214",
        "serial_number": "30214",
        "turbine": "20000000-0000-0000-0000-000000000072",
      },
      {
        "id": "30000000-0000-0000-0000-000000000215",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-215",
        "model": "m-215",
        "serial_number": "30215",
        "turbine": "20000000-0000-0000-0000-000000000072",
      },
      {
        "id": "30000000-0000-0000-0000-000000000216",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-216",
        "model": "m-216",
        "serial_number": "30216",
        "turbine": "20000000-0000-0000-0000-000000000072",
      },
      {
        "id": "30000000-0000-0000-0000-000000000217",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-217",
        "model": "m-217",
        "serial_number": "30217",
        "turbine": "20000000-0000-0000-0000-000000000073",
      },
      {
        "id": "30000000-0000-0000-0000-000000000218",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-218",
        "model": "m-218",
        "serial_number": "30218",
        "turbine": "20000000-0000-0000-0000-000000000073",
      },
      {
        "id": "30000000-0000-0000-0000-000000000219",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-219",
        "model": "m-219",
        "serial_number": "30219",
        "turbine": "20000000-0000-0000-0000-000000000073",
      },
      {
        "id": "30000000-0000-0000-0000-000000000220",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-220",
        "model": "m-220",
        "serial_number": "30220",
        "turbine": "20000000-0000-0000-0000-000000000074",
      },
      {
        "id": "30000000-0000-0000-0000-000000000221",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-221",
        "model": "m-221",
        "serial_number": "30221",
        "turbine": "20000000-0000-0000-0000-000000000074",
      },
      {
        "id": "30000000-0000-0000-0000-000000000222",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-222",
        "model": "m-222",
        "serial_number": "30222",
        "turbine": "20000000-0000-0000-0000-000000000074",
      },
      {
        "id": "30000000-0000-0000-0000-000000000223",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-223",
        "model": "m-223",
        "serial_number": "30223",
        "turbine": "20000000-0000-0000-0000-000000000075",
      },
      {
        "id": "30000000-0000-0000-0000-000000000224",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-224",
        "model": "m-224",
        "serial_number": "30224",
        "turbine": "20000000-0000-0000-0000-000000000075",
      },
      {
        "id": "30000000-0000-0000-0000-000000000225",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-225",
        "model": "m-225",
        "serial_number": "30225",
        "turbine": "20000000-0000-0000-0000-000000000075",
      },
      {
        "id": "30000000-0000-0000-0000-000000000226",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-226",
        "model": "m-226",
        "serial_number": "30226",
        "turbine": "20000000-0000-0000-0000-000000000076",
      },
      {
        "id": "30000000-0000-0000-0000-000000000227",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-227",
        "model": "m-227",
        "serial_number": "30227",
        "turbine": "20000000-0000-0000-0000-000000000076",
      },
      {
        "id": "30000000-0000-0000-0000-000000000228",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-228",
        "model": "m-228",
        "serial_number": "30228",
        "turbine": "20000000-0000-0000-0000-000000000076",
      },
      {
        "id": "30000000-0000-0000-0000-000000000229",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-229",
        "model": "m-229",
        "serial_number": "30229",
        "turbine": "20000000-0000-0000-0000-000000000077",
      },
      {
        "id": "30000000-0000-0000-0000-000000000230",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-230",
        "model": "m-230",
        "serial_number": "30230",
        "turbine": "20000000-0000-0000-0000-000000000077",
      },
      {
        "id": "30000000-0000-0000-0000-000000000231",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-231",
        "model": "m-231",
        "serial_number": "30231",
        "turbine": "20000000-0000-0000-0000-000000000077",
      },
      {
        "id": "30000000-0000-0000-0000-000000000232",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-232",
        "model": "m-232",
        "serial_number": "30232",
        "turbine": "20000000-0000-0000-0000-000000000078",
      },
      {
        "id": "30000000-0000-0000-0000-000000000233",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-233",
        "model": "m-233",
        "serial_number": "30233",
        "turbine": "20000000-0000-0000-0000-000000000078",
      },
      {
        "id": "30000000-0000-0000-0000-000000000234",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-234",
        "model": "m-234",
        "serial_number": "30234",
        "turbine": "20000000-0000-0000-0000-000000000078",
      },
      {
        "id": "30000000-0000-0000-0000-000000000235",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-235",
        "model": "m-235",
        "serial_number": "30235",
        "turbine": "20000000-0000-0000-0000-000000000079",
      },
      {
        "id": "30000000-0000-0000-0000-000000000236",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-236",
        "model": "m-236",
        "serial_number": "30236",
        "turbine": "20000000-0000-0000-0000-000000000079",
      },
      {
        "id": "30000000-0000-0000-0000-000000000237",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-237",
        "model": "m-237",
        "serial_number": "30237",
        "turbine": "20000000-0000-0000-0000-000000000079",
      },
      {
        "id": "30000000-0000-0000-0000-000000000238",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-238",
        "model": "m-238",
        "serial_number": "30238",
        "turbine": "20000000-0000-0000-0000-000000000080",
      },
      {
        "id": "30000000-0000-0000-0000-000000000239",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-239",
        "model": "m-239",
        "serial_number": "30239",
        "turbine": "20000000-0000-0000-0000-000000000080",
      },
      {
        "id": "30000000-0000-0000-0000-000000000240",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-240",
        "model": "m-240",
        "serial_number": "30240",
        "turbine": "20000000-0000-0000-0000-000000000080",
      },
      {
        "id": "30000000-0000-0000-0000-000000000241",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-241",
        "model": "m-241",
        "serial_number": "30241",
        "turbine": "20000000-0000-0000-0000-000000000081",
      },
      {
        "id": "30000000-0000-0000-0000-000000000242",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-242",
        "model": "m-242",
        "serial_number": "30242",
        "turbine": "20000000-0000-0000-0000-000000000081",
      },
      {
        "id": "30000000-0000-0000-0000-000000000243",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-243",
        "model": "m-243",
        "serial_number": "30243",
        "turbine": "20000000-0000-0000-0000-000000000081",
      },
      {
        "id": "30000000-0000-0000-0000-000000000244",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-244",
        "model": "m-244",
        "serial_number": "30244",
        "turbine": "20000000-0000-0000-0000-000000000082",
      },
      {
        "id": "30000000-0000-0000-0000-000000000245",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-245",
        "model": "m-245",
        "serial_number": "30245",
        "turbine": "20000000-0000-0000-0000-000000000082",
      },
      {
        "id": "30000000-0000-0000-0000-000000000246",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-246",
        "model": "m-246",
        "serial_number": "30246",
        "turbine": "20000000-0000-0000-0000-000000000082",
      },
      {
        "id": "30000000-0000-0000-0000-000000000247",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-247",
        "model": "m-247",
        "serial_number": "30247",
        "turbine": "20000000-0000-0000-0000-000000000083",
      },
      {
        "id": "30000000-0000-0000-0000-000000000248",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-248",
        "model": "m-248",
        "serial_number": "30248",
        "turbine": "20000000-0000-0000-0000-000000000083",
      },
      {
        "id": "30000000-0000-0000-0000-000000000249",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-249",
        "model": "m-249",
        "serial_number": "30249",
        "turbine": "20000000-0000-0000-0000-000000000083",
      },
      {
        "id": "30000000-0000-0000-0000-000000000250",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-250",
        "model": "m-250",
        "serial_number": "30250",
        "turbine": "20000000-0000-0000-0000-000000000084",
      },
      {
        "id": "30000000-0000-0000-0000-000000000251",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-251",
        "model": "m-251",
        "serial_number": "30251",
        "turbine": "20000000-0000-0000-0000-000000000084",
      },
      {
        "id": "30000000-0000-0000-0000-000000000252",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-252",
        "model": "m-252",
        "serial_number": "30252",
        "turbine": "20000000-0000-0000-0000-000000000084",
      },
      {
        "id": "30000000-0000-0000-0000-000000000253",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-253",
        "model": "m-253",
        "serial_number": "30253",
        "turbine": "20000000-0000-0000-0000-000000000085",
      },
      {
        "id": "30000000-0000-0000-0000-000000000254",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-254",
        "model": "m-254",
        "serial_number": "30254",
        "turbine": "20000000-0000-0000-0000-000000000085",
      },
      {
        "id": "30000000-0000-0000-0000-000000000255",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-255",
        "model": "m-255",
        "serial_number": "30255",
        "turbine": "20000000-0000-0000-0000-000000000085",
      },
      {
        "id": "30000000-0000-0000-0000-000000000256",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-256",
        "model": "m-256",
        "serial_number": "30256",
        "turbine": "20000000-0000-0000-0000-000000000086",
      },
      {
        "id": "30000000-0000-0000-0000-000000000257",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-257",
        "model": "m-257",
        "serial_number": "30257",
        "turbine": "20000000-0000-0000-0000-000000000086",
      },
      {
        "id": "30000000-0000-0000-0000-000000000258",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-258",
        "model": "m-258",
        "serial_number": "30258",
        "turbine": "20000000-0000-0000-0000-000000000086",
      },
      {
        "id": "30000000-0000-0000-0000-000000000259",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-259",
        "model": "m-259",
        "serial_number": "30259",
        "turbine": "20000000-0000-0000-0000-000000000087",
      },
      {
        "id": "30000000-0000-0000-0000-000000000260",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-260",
        "model": "m-260",
        "serial_number": "30260",
        "turbine": "20000000-0000-0000-0000-000000000087",
      },
      {
        "id": "30000000-0000-0000-0000-000000000261",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-261",
        "model": "m-261",
        "serial_number": "30261",
        "turbine": "20000000-0000-0000-0000-000000000087",
      },
      {
        "id": "30000000-0000-0000-0000-000000000262",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-262",
        "model": "m-262",
        "serial_number": "30262",
        "turbine": "20000000-0000-0000-0000-000000000088",
      },
      {
        "id": "30000000-0000-0000-0000-000000000263",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-263",
        "model": "m-263",
        "serial_number": "30263",
        "turbine": "20000000-0000-0000-0000-000000000088",
      },
      {
        "id": "30000000-0000-0000-0000-000000000264",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-264",
        "model": "m-264",
        "serial_number": "30264",
        "turbine": "20000000-0000-0000-0000-000000000088",
      },
      {
        "id": "30000000-0000-0000-0000-000000000265",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-265",
        "model": "m-265",
        "serial_number": "30265",
        "turbine": "20000000-0000-0000-0000-000000000089",
      },
      {
        "id": "30000000-0000-0000-0000-000000000266",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-266",
        "model": "m-266",
        "serial_number": "30266",
        "turbine": "20000000-0000-0000-0000-000000000089",
      },
      {
        "id": "30000000-0000-0000-0000-000000000267",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-267",
        "model": "m-267",
        "serial_number": "30267",
        "turbine": "20000000-0000-0000-0000-000000000089",
      },
      {
        "id": "30000000-0000-0000-0000-000000000268",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-268",
        "model": "m-268",
        "serial_number": "30268",
        "turbine": "20000000-0000-0000-0000-000000000090",
      },
      {
        "id": "30000000-0000-0000-0000-000000000269",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-269",
        "model": "m-269",
        "serial_number": "30269",
        "turbine": "20000000-0000-0000-0000-000000000090",
      },
      {
        "id": "30000000-0000-0000-0000-000000000270",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-270",
        "model": "m-270",
        "serial_number": "30270",
        "turbine": "20000000-0000-0000-0000-000000000090",
      },
      {
        "id": "30000000-0000-0000-0000-000000000271",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-271",
        "model": "m-271",
        "serial_number": "30271",
        "turbine": "20000000-0000-0000-0000-000000000091",
      },
      {
        "id": "30000000-0000-0000-0000-000000000272",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-272",
        "model": "m-272",
        "serial_number": "30272",
        "turbine": "20000000-0000-0000-0000-000000000091",
      },
      {
        "id": "30000000-0000-0000-0000-000000000273",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-273",
        "model": "m-273",
        "serial_number": "30273",
        "turbine": "20000000-0000-0000-0000-000000000091",
      },
      {
        "id": "30000000-0000-0000-0000-000000000274",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-274",
        "model": "m-274",
        "serial_number": "30274",
        "turbine": "20000000-0000-0000-0000-000000000092",
      },
      {
        "id": "30000000-0000-0000-0000-000000000275",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-275",
        "model": "m-275",
        "serial_number": "30275",
        "turbine": "20000000-0000-0000-0000-000000000092",
      },
      {
        "id": "30000000-0000-0000-0000-000000000276",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-276",
        "model": "m-276",
        "serial_number": "30276",
        "turbine": "20000000-0000-0000-0000-000000000092",
      },
      {
        "id": "30000000-0000-0000-0000-000000000277",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-277",
        "model": "m-277",
        "serial_number": "30277",
        "turbine": "20000000-0000-0000-0000-000000000093",
      },
      {
        "id": "30000000-0000-0000-0000-000000000278",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-278",
        "model": "m-278",
        "serial_number": "30278",
        "turbine": "20000000-0000-0000-0000-000000000093",
      },
      {
        "id": "30000000-0000-0000-0000-000000000279",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-279",
        "model": "m-279",
        "serial_number": "30279",
        "turbine": "20000000-0000-0000-0000-000000000093",
      },
      {
        "id": "30000000-0000-0000-0000-000000000280",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-280",
        "model": "m-280",
        "serial_number": "30280",
        "turbine": "20000000-0000-0000-0000-000000000094",
      },
      {
        "id": "30000000-0000-0000-0000-000000000281",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-281",
        "model": "m-281",
        "serial_number": "30281",
        "turbine": "20000000-0000-0000-0000-000000000094",
      },
      {
        "id": "30000000-0000-0000-0000-000000000282",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-282",
        "model": "m-282",
        "serial_number": "30282",
        "turbine": "20000000-0000-0000-0000-000000000094",
      },
      {
        "id": "30000000-0000-0000-0000-000000000283",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-283",
        "model": "m-283",
        "serial_number": "30283",
        "turbine": "20000000-0000-0000-0000-000000000095",
      },
      {
        "id": "30000000-0000-0000-0000-000000000284",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-284",
        "model": "m-284",
        "serial_number": "30284",
        "turbine": "20000000-0000-0000-0000-000000000095",
      },
      {
        "id": "30000000-0000-0000-0000-000000000285",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-285",
        "model": "m-285",
        "serial_number": "30285",
        "turbine": "20000000-0000-0000-0000-000000000095",
      },
      {
        "id": "30000000-0000-0000-0000-000000000286",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-286",
        "model": "m-286",
        "serial_number": "30286",
        "turbine": "20000000-0000-0000-0000-000000000096",
      },
      {
        "id": "30000000-0000-0000-0000-000000000287",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-287",
        "model": "m-287",
        "serial_number": "30287",
        "turbine": "20000000-0000-0000-0000-000000000096",
      },
      {
        "id": "30000000-0000-0000-0000-000000000288",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-288",
        "model": "m-288",
        "serial_number": "30288",
        "turbine": "20000000-0000-0000-0000-000000000096",
      },
      {
        "id": "30000000-0000-0000-0000-000000000289",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-289",
        "model": "m-289",
        "serial_number": "30289",
        "turbine": "20000000-0000-0000-0000-000000000097",
      },
      {
        "id": "30000000-0000-0000-0000-000000000290",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-290",
        "model": "m-290",
        "serial_number": "30290",
        "turbine": "20000000-0000-0000-0000-000000000097",
      },
      {
        "id": "30000000-0000-0000-0000-000000000291",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-291",
        "model": "m-291",
        "serial_number": "30291",
        "turbine": "20000000-0000-0000-0000-000000000097",
      },
      {
        "id": "30000000-0000-0000-0000-000000000292",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-292",
        "model": "m-292",
        "serial_number": "30292",
        "turbine": "20000000-0000-0000-0000-000000000098",
      },
      {
        "id": "30000000-0000-0000-0000-000000000293",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-293",
        "model": "m-293",
        "serial_number": "30293",
        "turbine": "20000000-0000-0000-0000-000000000098",
      },
      {
        "id": "30000000-0000-0000-0000-000000000294",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-294",
        "model": "m-294",
        "serial_number": "30294",
        "turbine": "20000000-0000-0000-0000-000000000098",
      },
      {
        "id": "30000000-0000-0000-0000-000000000295",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-295",
        "model": "m-295",
        "serial_number": "30295",
        "turbine": "20000000-0000-0000-0000-000000000099",
      },
      {
        "id": "30000000-0000-0000-0000-000000000296",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-296",
        "model": "m-296",
        "serial_number": "30296",
        "turbine": "20000000-0000-0000-0000-000000000099",
      },
      {
        "id": "30000000-0000-0000-0000-000000000297",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-297",
        "model": "m-297",
        "serial_number": "30297",
        "turbine": "20000000-0000-0000-0000-000000000099",
      },
      {
        "id": "30000000-0000-0000-0000-000000000298",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-298",
        "model": "m-298",
        "serial_number": "30298",
        "turbine": "20000000-0000-0000-0000-000000000100",
      },
      {
        "id": "30000000-0000-0000-0000-000000000299",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-299",
        "model": "m-299",
        "serial_number": "30299",
        "turbine": "20000000-0000-0000-0000-000000000100",
      },
      {
        "id": "30000000-0000-0000-0000-000000000300",
        "created_at": "2026-04-02T07:39:44.060869Z",
        "updated_at": "2026-04-02T07:39:44.060869Z",
        "manufacturer": "mf-300",
        "model": "m-300",
        "serial_number": "30300",
        "turbine": "20000000-0000-0000-0000-000000000100",
      },
    ],
    "technicians": [
      {
        "id": 3,
        "username": "user2",
        "email": "user2@email.com",
      },
    ],
  });
}
